import { Component, Inject,ChangeDetectionStrategy, OnDestroy } from "@angular/core";
import { FormControl, FormGroup, FormBuilder, Validators, FormArray } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { GroupService } from "../../shared/services/group/group.service";
import { Observable } from "rxjs/Observable";
import { Brand } from "../../shared/interface/brand";
import { Zone } from "../../shared/interface/zone";
import { Site, GeoSegments } from "../../shared/interface/site";
import { CommonService } from '../../shared/services/common/common.service';
import { KpiGroups } from "../../shared/interface/kpi-groups";
import { Router, ActivatedRoute } from "@angular/router";
import { WidgetService } from "../../shared/services/widget/widget.service";
import { EventService } from "../../shared/services/event/event.service";
import { DataFilter, binFilter } from "../../shared/interface/widget";
import { GeoFilterNext } from "../../shared/interface/geosite";
import { ReplaySubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as moment from 'moment'
import { UserService } from "../../shared/services";

//add edit chart name
@Component({
  selector: "chart-dialog",
  styleUrls: ['chart.dialog.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush,
  templateUrl: "chart.dialog.html"
})
export class ChartDialog implements OnDestroy{
  dashboardId: string;
  chartForm: FormGroup;
  siteList$: Observable<Site[]>;
  brandList: Brand[];
  zoneList: Zone[];
  deviceList = [];
  selectedBrands = [];
  selectedZones = [];
  selectedDevices = [];
  kpiGroupList$: Observable<KpiGroups[]>;
  kpiList = [];
  protected geoSegments: GeoSegments[] = [];
  protected _onDestroy = new Subject<void>();
  public segFilterCtrl: FormControl = new FormControl();
  public segmentsList: ReplaySubject<GeoSegments[]> = new ReplaySubject<GeoSegments[]>(1);
  kpiElementList = [];
  kpiElementMultiSelect = [];
  dashboardGroups = [];
  isPredictiveSearch = false;
  kpiType: string = "";
  isSubmitted: number = 0;
  boxColor: string[] = ["#ffffff", "#000000", "#000000", "#ffffff", "#000", "#ffffff", "#000", "#059505", "#bdbd05", "#d18904"];
  chartLabelColor = [];
  // filter00ColorObj = [];
  // filter30ColorObj = [];
  // filter60ColorObj = [];
  isLocalFilter = false;
  htmlContentRichText: any = "";
  maxdataFilter: number = 1;
  editGeoConfigObj: any = null;
  isGeoMap = false;
  eventList: any = [];
  selectedEventList: any = [];
  isvalueType: boolean = false;
  isSelected: boolean = false;
  displayMessage: any = '';
  defaultWidth: any = '';
  image_url: any;
  imageName: string;
  user : any;
  // showNumericConfig:boolean=false;
  ckEditorConfig: any = {
    uiColor: '#f2f6f8',
    language: 'en',
    valid_elements: '+*[*]',
    valid_children: '+body[style], +p[style],+body[link], +p[link], +div[style], +div[link], +h1[style], +h1[link], +h2[style], +h2[link], +h3[style], +h3[link], +h4[style], +h4[link], +h5[style], +h5[link], +h6[style], +h6[link]',
    toolbarGroups: [
      { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
      { name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align', 'bidi', 'paragraph'] },
      { name: 'document', groups: ['mode', 'document', 'doctools'] },
      { name: 'editing', groups: ['find', 'selection', 'spellchecker', 'editing'] },
      '/',
      { name: 'styles', groups: ['styles'] },
      { name: 'colors', groups: ['colors'] },
      { name: 'clipboard', groups: ['clipboard', 'undo'] },
      '/',
      { name: 'forms', groups: ['forms'] },
      { name: 'links', groups: ['links'] },
      { name: 'insert', groups: ['insert'] },
      { name: 'tools', groups: ['tools'] },
      { name: 'others', groups: ['others'] },
      { name: 'about', groups: ['about'] }
    ],
    removePlugins: 'image',
    // extraPlugins: 'image2',
    removeButtons: 'Save,image,Templates,Find,Form,Checkbox,Radio,TextField,Textarea,Select,Button,ImageButton,HiddenField,Print,Preview,NewPage,Replace,Flash,PageBreak,Maximize,ShowBlocks,About'
  };
  isPresentationErr = [false];
  thresholdColorAr = ["#e1ffe8", "#ffede1", "#ffffda", "#ffdbdb", "#c4f3af"];
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public fb: FormBuilder,
    public dialogRef: MatDialogRef<ChartDialog>,
    private widgetService: WidgetService,
    private groupService: GroupService,
    public router: Router,
    private commonService: CommonService,
    private activatedRoute: ActivatedRoute,
    private eventService: EventService,
    private userService: UserService
  ) {
    if (localStorage.getItem("widgetWidthdsxcmt") != "" && localStorage.getItem("widgetWidthdsxcmt") != undefined && localStorage.getItem("widgetWidthdsxcmt") != null && atob(localStorage.getItem("widgetWidthdsxcmt")) != "undefined")
      this.defaultWidth = JSON.parse(atob(localStorage.getItem("widgetWidthdsxcmt")));
    this.siteList$ = this.widgetService.siteList();
    this.kpiGroupList$ = this.widgetService.kpiGroupList();
    this.dashboardId = data.dashboardId;
    this.dashboardGroups = data.groupList;
    this.getSegmentsList();
    data = this.parseData(data);
    if (data && data.widgetData.compareConfig && data.widgetData.compareConfig.fetchDataFor) {
      this.getEventList(true);
    }
    this.createForm(data);
    this.setDataFilterMaxLimit();
    // this.isPredictiveSearch=data.widgetData.isPredictiveSearch
    // console.log(this.dashboardGroups)
    this.user = this.userService.getLoggedInUser();
  }

  loadKpiList(kpiGrpoupId, index) {
    this.kpiList[index] = [];
    this.kpiType = this.chartForm.controls["kpiType"].value;
    //if trend or performers pass it as count
    this.kpiType = ["trend", "performers"].includes(this.kpiType) ? "count" : this.kpiType;
    // this.kpiType = this.kpiType ==  "trend" ? "count" : this.kpiType;
    this.widgetService.kpiList(kpiGrpoupId).pipe(takeUntil(this._onDestroy)).subscribe(
      r => {
        this.chartForm.controls.dataFilter["controls"][index].controls[
          "kpiId"
        ].setValue("");
        this.chartForm.controls.dataFilter["controls"][index].controls[
          "elementId"
        ].setValue([]);
        r.forEach(v => {
          if (v.kpiType && v.kpiType.includes(this.kpiType)) {
            this.kpiList[index].push(v);
          }
        });
      },
      err => { }
    );
  }

  getSegmentsList() {
    if (localStorage.getItem("getSegsdsxcmt")) {
      this.geoSegments = JSON.parse(atob(localStorage.getItem("getSegsdsxcmt")));
      this.segmentsList.next(this.geoSegments.slice());
      this.segFilterCtrl.valueChanges
        .pipe(takeUntil(this._onDestroy))
        .subscribe(() => {
          this.filterBanksMulti();
        });
    }
  }

  protected filterBanksMulti() {
    if (!this.geoSegments) {
      return;
    }
    // get the search keyword
    let search = this.segFilterCtrl.value;
    if (!search) {
      this.segmentsList.next(this.geoSegments.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.segmentsList.next(
      this.geoSegments.filter(seg => seg.segementName.toLowerCase().indexOf(search) > -1)
    );
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  loadElementList(kpiListId, index) {
    this.kpiElementList[index] = [];
    let kpiList = this.kpiList[index].filter(item => item._id === kpiListId);
    if (kpiList[0].elements && kpiList[0].elements.constructor == Array) {
      this.kpiElementMultiSelect[index] = (kpiList[0].isElementMultiSelect ? true : false)
      this.chartForm.controls.dataFilter["controls"][index].controls[
        "elementId"
      ].setValue([]);
      kpiList[0].elements.forEach((v, i) => {
        if (v.value || v.value == 0) {
          this.kpiElementList[index].push(v);
        }
      });
    }
  }

  ChangeDisplayStatus(value:string,index : number){
    this.getdataFilter().at(index).get('displayType').setValue(value);
    if(value == "percentage"){
      this.getdataFilter().at(index).get('kpiNumberFormat').setValue(2);
    }
    // this.getdataFilter().value.forEach((d,index)=>{
    //   this.getdataFilter().at(index).get('displayType').setValue(value);
    //   if(value == "percentage"){
    //     this.getdataFilter().at(index).get('kpiNumberFormat').setValue(2);
    //   }
    // })
  }

  ChangePredictiveStatus(groupId) {
    let selectedGroup = this.dashboardGroups.filter(item => item._id === groupId);
    if (selectedGroup[0]) {
      this.data.isPredictive = selectedGroup[0].isPredictive;
    }
  }
  changeValueTypeName(name: any, type: any) {
    if (type == 'difference' && name.toLowerCase() == this.chartForm.get('compareConfig').get('valueType').get('variationName').value.toLowerCase())
      this.chartForm.get('compareConfig').get('valueType').get('differenceName').patchValue('Difference');
    else if (type == 'variation' && name.toLowerCase() == this.chartForm.get('compareConfig').get('valueType').get('differenceName').value.toLowerCase())
      this.chartForm.get('compareConfig').get('valueType').get('variationName').patchValue('Variation');
  }

  loadDeviceListForSite(index) {
    let sitefrm = <FormControl>this.chartForm.get("dataFilter." + index + ".mapped.siteId")
    if (sitefrm == null)
      return;
    let siteId = sitefrm.value;
    if (!siteId) {
      return;
    }
    this.widgetService.deviceList("", "", siteId).pipe(takeUntil(this._onDestroy)).subscribe(res => {
      this.deviceList[index] = res;
    })
  }

  get dataFilter(): FormArray {
    return this.chartForm.get("dataFilter") as FormArray;
  }

  get binFilter(): FormArray {
    return this.chartForm.get("binFilter") as FormArray;
  }

  getdataFilter() {
    return <FormArray>this.chartForm.get('dataFilter');
  }

  getBinFilter() {
    return <FormArray>this.chartForm.get('binFilter');
  }

  getCountConfig() {
    return <FormGroup>this.chartForm.get('countConfig');
  }

  createForm(data) {
    this.chartForm = this.fb.group({
      _id: data.widgetData._id,
      dashboardId: data.widgetData.dashboardId,
      groupId: [data.widgetData.groupId, Validators.required],
      title: [data.widgetData.title, Validators.required],
      order: data.widgetData.order,
      compareConfig: this.fb.group({
        fetchDataFor: (data.widgetData.compareConfig && data.widgetData.compareConfig.fetchDataFor) ? data.widgetData.compareConfig.fetchDataFor : "",
        compareType: (data.widgetData.compareConfig && data.widgetData.compareConfig.compareType) ? data.widgetData.compareConfig.compareType : "",
        fromDate: (data.widgetData.compareConfig && data.widgetData.compareConfig.fromDate) ? this.commonService.getDateConverted(data.widgetData.compareConfig.fromDate, "YYYY-MM-DD HH:mm:ss") : "",
        toDate: (data.widgetData.compareConfig && data.widgetData.compareConfig.toDate) ? this.commonService.getDateConverted(data.widgetData.compareConfig.toDate, "YYYY-MM-DD HH:mm:ss") : "",
        eventId: (data.widgetData.compareConfig && data.widgetData.compareConfig.eventId) ? data.widgetData.compareConfig.eventId : "",
        displayName: (data.widgetData.compareConfig && data.widgetData.compareConfig.displayName) ? data.widgetData.compareConfig.displayName : "",
        color: (data.widgetData.compareConfig && data.widgetData.compareConfig.color) ? data.widgetData.compareConfig.color : "random",
        range1: this.fb.group({
          eventId: (data.widgetData.compareConfig && data.widgetData.compareConfig.range1 && data.widgetData.compareConfig.range1.eventId) ? data.widgetData.compareConfig.range1.eventId : "",
          enabled: (data.widgetData.compareConfig && data.widgetData.compareConfig.range1 && data.widgetData.compareConfig.range1.enabled) ? data.widgetData.compareConfig.range1.enabled : false,
          fromDate: (data.widgetData.compareConfig && data.widgetData.compareConfig.range1 && data.widgetData.compareConfig.range1.fromDate) ? this.commonService.getDateConverted(data.widgetData.compareConfig.range1.fromDate, "YYYY-MM-DD HH:mm:ss") : "",
          toDate: (data.widgetData.compareConfig && data.widgetData.compareConfig.range1 && data.widgetData.compareConfig.range1.toDate) ? this.commonService.getDateConverted(data.widgetData.compareConfig.range1.toDate, "YYYY-MM-DD HH:mm:ss") : "",
          displayName: (data.widgetData.compareConfig && data.widgetData.compareConfig.range1 && data.widgetData.compareConfig.range1.displayName) ? data.widgetData.compareConfig.range1.displayName : "",
          color: (data.widgetData.compareConfig && data.widgetData.compareConfig.range1 && data.widgetData.compareConfig.range1.color) ? data.widgetData.compareConfig.range1.color : "random",
        }),
        range2: this.fb.group({
          eventId: (data.widgetData.compareConfig && data.widgetData.compareConfig.range2 && data.widgetData.compareConfig.range2.eventId) ? data.widgetData.compareConfig.range2.eventId : "",
          enabled: (data.widgetData.compareConfig && data.widgetData.compareConfig.range2 && data.widgetData.compareConfig.range2.enabled) ? data.widgetData.compareConfig.range2.enabled : false,
          fromDate: (data.widgetData.compareConfig && data.widgetData.compareConfig.range2 && data.widgetData.compareConfig.range2.fromDate) ? this.commonService.getDateConverted(data.widgetData.compareConfig.range2.fromDate, "YYYY-MM-DD HH:mm:ss") : "",
          toDate: (data.widgetData.compareConfig && data.widgetData.compareConfig.range2 && data.widgetData.compareConfig.range2.toDate) ? this.commonService.getDateConverted(data.widgetData.compareConfig.range2.toDate, "YYYY-MM-DD HH:mm:ss") : "",
          displayName: (data.widgetData.compareConfig && data.widgetData.compareConfig.range2 && data.widgetData.compareConfig.range2.displayName) ? data.widgetData.compareConfig.range2.displayName : "",
          color: (data.widgetData.compareConfig && data.widgetData.compareConfig.range2 && data.widgetData.compareConfig.range2.color) ? data.widgetData.compareConfig.range2.color : "random",
        }),
        range3: this.fb.group({
          eventId: (data.widgetData.compareConfig && data.widgetData.compareConfig.range3 && data.widgetData.compareConfig.range3.eventId) ? data.widgetData.compareConfig.range3.eventId : "",
          enabled: (data.widgetData.compareConfig && data.widgetData.compareConfig.range3 && data.widgetData.compareConfig.range3.enabled) ? data.widgetData.compareConfig.range3.enabled : false,
          fromDate: (data.widgetData.compareConfig && data.widgetData.compareConfig.range3 && data.widgetData.compareConfig.range3.fromDate) ? this.commonService.getDateConverted(data.widgetData.compareConfig.range3.fromDate, "YYYY-MM-DD HH:mm:ss") : "",
          toDate: (data.widgetData.compareConfig && data.widgetData.compareConfig.range3 && data.widgetData.compareConfig.range3.toDate) ? this.commonService.getDateConverted(data.widgetData.compareConfig.range3.toDate, "YYYY-MM-DD HH:mm:ss") : "",
          displayName: (data.widgetData.compareConfig && data.widgetData.compareConfig.range3 && data.widgetData.compareConfig.range3.displayName) ? data.widgetData.compareConfig.range3.displayName : "",
          color: (data.widgetData.compareConfig && data.widgetData.compareConfig.range3 && data.widgetData.compareConfig.range3.color) ? data.widgetData.compareConfig.range3.color : "random",
        }),
        range4: this.fb.group({
          eventId: (data.widgetData.compareConfig && data.widgetData.compareConfig.range4 && data.widgetData.compareConfig.range4.eventId) ? data.widgetData.compareConfig.range4.eventId : "",
          enabled: (data.widgetData.compareConfig && data.widgetData.compareConfig.range4 && data.widgetData.compareConfig.range4.enabled) ? data.widgetData.compareConfig.range4.enabled : false,
          fromDate: (data.widgetData.compareConfig && data.widgetData.compareConfig.range4 && data.widgetData.compareConfig.range4.fromDate) ? this.commonService.getDateConverted(data.widgetData.compareConfig.range4.fromDate, "YYYY-MM-DD HH:mm:ss") : "",
          toDate: (data.widgetData.compareConfig && data.widgetData.compareConfig.range4 && data.widgetData.compareConfig.range4.toDate) ? this.commonService.getDateConverted(data.widgetData.compareConfig.range4.toDate, "YYYY-MM-DD HH:mm:ss") : "",
          displayName: (data.widgetData.compareConfig && data.widgetData.compareConfig.range4 && data.widgetData.compareConfig.range4.displayName) ? data.widgetData.compareConfig.range4.displayName : "",
          color: (data.widgetData.compareConfig && data.widgetData.compareConfig.range4 && data.widgetData.compareConfig.range4.color) ? data.widgetData.compareConfig.range4.color : "random",
        }),
        range5: this.fb.group({
          eventId: (data.widgetData.compareConfig && data.widgetData.compareConfig.range5 && data.widgetData.compareConfig.range5.eventId) ? data.widgetData.compareConfig.range5.eventId : "",
          enabled: (data.widgetData.compareConfig && data.widgetData.compareConfig.range5 && data.widgetData.compareConfig.range5.enabled) ? data.widgetData.compareConfig.range5.enabled : false,
          fromDate: (data.widgetData.compareConfig && data.widgetData.compareConfig.range5 && data.widgetData.compareConfig.range5.fromDate) ? this.commonService.getDateConverted(data.widgetData.compareConfig.range5.fromDate, "YYYY-MM-DD HH:mm:ss") : "",
          toDate: (data.widgetData.compareConfig && data.widgetData.compareConfig.range5 && data.widgetData.compareConfig.range5.toDate) ? this.commonService.getDateConverted(data.widgetData.compareConfig.range5.toDate, "YYYY-MM-DD HH:mm:ss") : "",
          displayName: (data.widgetData.compareConfig && data.widgetData.compareConfig.range5 && data.widgetData.compareConfig.range5.displayName) ? data.widgetData.compareConfig.range5.displayName : "",
          color: (data.widgetData.compareConfig && data.widgetData.compareConfig.range5 && data.widgetData.compareConfig.range5.color) ? data.widgetData.compareConfig.range5.color : "random",
        }),
        valueType: this.fb.group({
          Value: (data.widgetData.compareConfig && data.widgetData.compareConfig.valueType && data.widgetData.compareConfig.valueType.Value == false) ? data.widgetData.compareConfig.valueType.Value : true,
          Variation: (data.widgetData.compareConfig && data.widgetData.compareConfig.valueType && data.widgetData.compareConfig.valueType.Variation) ? data.widgetData.compareConfig.valueType.Variation : false,
          Difference: (data.widgetData.compareConfig && data.widgetData.compareConfig.valueType && data.widgetData.compareConfig.valueType.Difference) ? data.widgetData.compareConfig.valueType.Difference : false,
          variationName: [(data.widgetData.compareConfig && data.widgetData.compareConfig.valueType && data.widgetData.compareConfig.valueType.variationName) ? data.widgetData.compareConfig.valueType.variationName : "Variation", Validators.compose([Validators.pattern('^(?=.*[A-Za-z0-9])[\\S]*')])],
          differenceName: [(data.widgetData.compareConfig && data.widgetData.compareConfig.valueType && data.widgetData.compareConfig.valueType.differenceName) ? data.widgetData.compareConfig.valueType.differenceName : "Difference", Validators.compose([Validators.pattern('^(?=.*[A-Za-z0-9])[\\S]*')])],
        }),
        displayRange: (data.widgetData.compareConfig && data.widgetData.compareConfig.displayRange) ? data.widgetData.compareConfig.displayRange : "selected",
        segregateDate: (data.widgetData.compareConfig && data.widgetData.compareConfig.segregateDate) ? data.widgetData.compareConfig.segregateDate : "dates",
        segregateName: [(data.widgetData.compareConfig && data.widgetData.compareConfig.segregateName) ? data.widgetData.compareConfig.segregateName : "Dates", Validators.compose([Validators.pattern('^(?=.*[A-Za-z0-9])[\\S]*')])],
        weekDays: this.fb.group({
          monday: (data.widgetData.compareConfig && data.widgetData.compareConfig.weekDays && data.widgetData.compareConfig.weekDays.monday == false) ? data.widgetData.compareConfig.weekDays.monday : true,
          tuesday: (data.widgetData.compareConfig && data.widgetData.compareConfig.weekDays && data.widgetData.compareConfig.weekDays.tuesday == false) ? data.widgetData.compareConfig.weekDays.tuesday : true,
          wednesday: (data.widgetData.compareConfig && data.widgetData.compareConfig.weekDays && data.widgetData.compareConfig.weekDays.wednesday == false) ? data.widgetData.compareConfig.weekDays.wednesday : true,
          thursday: (data.widgetData.compareConfig && data.widgetData.compareConfig.weekDays && data.widgetData.compareConfig.weekDays.thursday == false) ? data.widgetData.compareConfig.weekDays.thursday : true,
          friday: (data.widgetData.compareConfig && data.widgetData.compareConfig.weekDays && data.widgetData.compareConfig.weekDays.friday == false) ? data.widgetData.compareConfig.weekDays.friday : true,
          saturday: (data.widgetData.compareConfig && data.widgetData.compareConfig.weekDays && data.widgetData.compareConfig.weekDays.saturday == false) ? data.widgetData.compareConfig.weekDays.saturday : true,
          sunday: (data.widgetData.compareConfig && data.widgetData.compareConfig.weekDays && data.widgetData.compareConfig.weekDays.sunday == false) ? data.widgetData.compareConfig.weekDays.sunday : true,
        }),
        dayWeek: this.fb.group({
          monday: (data.widgetData.compareConfig && data.widgetData.compareConfig.dayWeek && data.widgetData.compareConfig.dayWeek.monday == false) ? data.widgetData.compareConfig.dayWeek.monday : true,
          tuesday: (data.widgetData.compareConfig && data.widgetData.compareConfig.dayWeek && data.widgetData.compareConfig.dayWeek.tuesday == false) ? data.widgetData.compareConfig.dayWeek.tuesday : true,
          wednesday: (data.widgetData.compareConfig && data.widgetData.compareConfig.dayWeek && data.widgetData.compareConfig.dayWeek.wednesday == false) ? data.widgetData.compareConfig.dayWeek.wednesday : true,
          thursday: (data.widgetData.compareConfig && data.widgetData.compareConfig.dayWeek && data.widgetData.compareConfig.dayWeek.thursday == false) ? data.widgetData.compareConfig.dayWeek.thursday : true,
          friday: (data.widgetData.compareConfig && data.widgetData.compareConfig.dayWeek && data.widgetData.compareConfig.dayWeek.friday == false) ? data.widgetData.compareConfig.dayWeek.friday : true,
          saturday: (data.widgetData.compareConfig && data.widgetData.compareConfig.dayWeek && data.widgetData.compareConfig.dayWeek.saturday == false) ? data.widgetData.compareConfig.dayWeek.saturday : true,
          sunday: (data.widgetData.compareConfig && data.widgetData.compareConfig.dayWeek && data.widgetData.compareConfig.dayWeek.sunday == false) ? data.widgetData.compareConfig.dayWeek.sunday : true,
        }),
        tableAggregator: this.fb.group({
          total: (data.widgetData.compareConfig && data.widgetData.compareConfig.tableAggregator && data.widgetData.compareConfig.tableAggregator.total == true) ? data.widgetData.compareConfig.tableAggregator.total : false,
          count: (data.widgetData.compareConfig && data.widgetData.compareConfig.tableAggregator && data.widgetData.compareConfig.tableAggregator.count == true) ? data.widgetData.compareConfig.tableAggregator.count : false,
          average: (data.widgetData.compareConfig && data.widgetData.compareConfig.tableAggregator && data.widgetData.compareConfig.tableAggregator.average == true) ? data.widgetData.compareConfig.tableAggregator.average : false,
          min: (data.widgetData.compareConfig && data.widgetData.compareConfig.tableAggregator && data.widgetData.compareConfig.tableAggregator.min == true) ? data.widgetData.compareConfig.tableAggregator.min : false,
          max: (data.widgetData.compareConfig && data.widgetData.compareConfig.tableAggregator && data.widgetData.compareConfig.tableAggregator.max == true) ? data.widgetData.compareConfig.tableAggregator.max : false,
        }),
        aggregatorNames: this.fb.group({
          totalName: [(data.widgetData.compareConfig && data.widgetData.compareConfig.aggregatorNames && data.widgetData.compareConfig.aggregatorNames.totalName) ? data.widgetData.compareConfig.aggregatorNames.totalName : 'Total', Validators.compose([Validators.pattern('^(?=.*[A-Za-z0-9])[\\S]*')])],
          countName: [(data.widgetData.compareConfig && data.widgetData.compareConfig.aggregatorNames && data.widgetData.compareConfig.aggregatorNames.countName) ? data.widgetData.compareConfig.aggregatorNames.countName : 'Count', Validators.compose([Validators.pattern('^(?=.*[A-Za-z0-9])[\\S]*')])],
          averageName: [(data.widgetData.compareConfig && data.widgetData.compareConfig.aggregatorNames && data.widgetData.compareConfig.aggregatorNames.averageName) ? data.widgetData.compareConfig.aggregatorNames.averageName : 'Average', Validators.compose([Validators.pattern('^(?=.*[A-Za-z0-9])[\\S]*')])],
          minName: [(data.widgetData.compareConfig && data.widgetData.compareConfig.aggregatorNames && data.widgetData.compareConfig.aggregatorNames.minName) ? data.widgetData.compareConfig.aggregatorNames.minName : 'Min', Validators.compose([Validators.pattern('^(?=.*[A-Za-z0-9])[\\S]*')])],
          maxName: [(data.widgetData.compareConfig && data.widgetData.compareConfig.aggregatorNames && data.widgetData.compareConfig.aggregatorNames.maxName) ? data.widgetData.compareConfig.aggregatorNames.maxName : 'Max', Validators.compose([Validators.pattern('^(?=.*[A-Za-z0-9])[\\S]*')])],
        }),
        tableIndicator: this.fb.group({
          color: (data.widgetData.compareConfig && data.widgetData.compareConfig.tableIndicator && data.widgetData.compareConfig.tableIndicator.color == true) ? data.widgetData.compareConfig.tableIndicator.color : false,
          arrow: (data.widgetData.compareConfig && data.widgetData.compareConfig.tableIndicator && data.widgetData.compareConfig.tableIndicator.arrow == true) ? data.widgetData.compareConfig.tableIndicator.arrow : false,
        }),
        differenceTiming: this.fb.group({
          day: (data.widgetData.compareConfig && data.widgetData.compareConfig.differenceTiming && data.widgetData.compareConfig.differenceTiming.day == true) ? data.widgetData.compareConfig.differenceTiming.day : false,
          date: (data.widgetData.compareConfig && data.widgetData.compareConfig.differenceTiming && data.widgetData.compareConfig.differenceTiming.date == true) ? data.widgetData.compareConfig.differenceTiming.date : false,
        }),
        tableAdjust: this.fb.group({
          tableHeight: (data.widgetData.compareConfig && data.widgetData.compareConfig.tableAdjust && data.widgetData.compareConfig.tableAdjust.tableHeight == true) ? data.widgetData.compareConfig.tableAdjust.tableHeight : false,
          tableWidth: (data.widgetData.compareConfig && data.widgetData.compareConfig.tableAdjust && data.widgetData.compareConfig.tableAdjust.tableWidth == true) ? data.widgetData.compareConfig.tableAdjust.tableWidth : false,
          tableRows: (data.widgetData.compareConfig && data.widgetData.compareConfig.tableAdjust && data.widgetData.compareConfig.tableAdjust.tableRows) ? data.widgetData.compareConfig.tableAdjust.tableRows : "",
          tableHeader: (data.widgetData.compareConfig && data.widgetData.compareConfig.tableAdjust && data.widgetData.compareConfig.tableAdjust.tableHeader == true) ? data.widgetData.compareConfig.tableAdjust.tableHeader : false,
        }),
      }),
      compareDateConfig : this.fb.group({
        fetchDataFor: (data.widgetData.compareDateConfig && data.widgetData.compareDateConfig.fetchDataFor) ? data.widgetData.compareDateConfig.fetchDataFor : "",
        compareType: (data.widgetData.compareDateConfig && data.widgetData.compareDateConfig.compareType) ? data.widgetData.compareDateConfig.compareType : "",
        dateType: (data.widgetData.compareDateConfig && data.widgetData.compareDateConfig.dateType) ? data.widgetData.compareDateConfig.dateType : "customDate",
        fromDate: (data.widgetData.compareDateConfig && data.widgetData.compareDateConfig.fromDate) ? this.commonService.getDateConverted(data.widgetData.compareDateConfig.fromDate, "YYYY-MM-DD HH:mm:ss") : "",
        toDate: (data.widgetData.compareDateConfig && data.widgetData.compareDateConfig.toDate) ? this.commonService.getDateConverted(data.widgetData.compareDateConfig.toDate, "YYYY-MM-DD HH:mm:ss") : "",
        date1: this.fb.group({
          enabled: (data.widgetData.compareDateConfig && data.widgetData.compareDateConfig.date1 && data.widgetData.compareDateConfig.date1.enabled) ? data.widgetData.compareDateConfig.date1.enabled : false,
          displayName: (data.widgetData.compareDateConfig && data.widgetData.compareDateConfig.date1 && data.widgetData.compareDateConfig.date1.displayName) ? data.widgetData.compareDateConfig.date1.displayName : "",
          color: (data.widgetData.compareDateConfig && data.widgetData.compareDateConfig.date1 && data.widgetData.compareDateConfig.date1.color) ? data.widgetData.compareDateConfig.date1.color : "random",
        }),
        date2: this.fb.group({
          enabled: (data.widgetData.compareDateConfig && data.widgetData.compareDateConfig.date2 && data.widgetData.compareDateConfig.date2.enabled) ? data.widgetData.compareDateConfig.date2.enabled : false,
          displayName: (data.widgetData.compareDateConfig && data.widgetData.compareDateConfig.date2 && data.widgetData.compareDateConfig.date2.displayName) ? data.widgetData.compareDateConfig.date2.displayName : "",
          color: (data.widgetData.compareDateConfig && data.widgetData.compareDateConfig.date2 && data.widgetData.compareDateConfig.date2.color) ? data.widgetData.compareDateConfig.date2.color : "random",
        }),
        date3: this.fb.group({
          enabled: (data.widgetData.compareDateConfig && data.widgetData.compareDateConfig.date3 && data.widgetData.compareDateConfig.date3.enabled) ? data.widgetData.compareDateConfig.date3.enabled : false,
          displayName: (data.widgetData.compareDateConfig && data.widgetData.compareDateConfig.date3 && data.widgetData.compareDateConfig.date3.displayName) ? data.widgetData.compareDateConfig.date3.displayName : "",
          color: (data.widgetData.compareDateConfig && data.widgetData.compareDateConfig.date3 && data.widgetData.compareDateConfig.date3.color) ? data.widgetData.compareDateConfig.date3.color : "random",
        }),
        date4: this.fb.group({
          enabled: (data.widgetData.compareDateConfig && data.widgetData.compareDateConfig.date4 && data.widgetData.compareDateConfig.date4.enabled) ? data.widgetData.compareDateConfig.date4.enabled : false,
          displayName: (data.widgetData.compareDateConfig && data.widgetData.compareDateConfig.date4 && data.widgetData.compareDateConfig.date4.displayName) ? data.widgetData.compareDateConfig.date4.displayName : "",
          color: (data.widgetData.compareDateConfig && data.widgetData.compareDateConfig.date4 && data.widgetData.compareDateConfig.date4.color) ? data.widgetData.compareDateConfig.date4.color : "random",
        }),
        valueType: this.fb.group({
          lastYear: (data.widgetData.compareDateConfig && data.widgetData.compareDateConfig.valueType && data.widgetData.compareDateConfig.valueType.lastYear) ? data.widgetData.compareDateConfig.valueType.lastYear : false,
          // Value: (data.widgetData.compareDateConfig && data.widgetData.compareDateConfig.valueType && data.widgetData.compareDateConfig.valueType.Value == false) ? data.widgetData.compareDateConfig.valueType.Value : true,
          Variation: (data.widgetData.compareDateConfig && data.widgetData.compareDateConfig.valueType && data.widgetData.compareDateConfig.valueType.Variation) ? data.widgetData.compareDateConfig.valueType.Variation : false,
          Difference: (data.widgetData.compareDateConfig && data.widgetData.compareDateConfig.valueType && data.widgetData.compareDateConfig.valueType.Difference) ? data.widgetData.compareDateConfig.valueType.Difference : false,
          variationName: [(data.widgetData.compareDateConfig && data.widgetData.compareDateConfig.valueType && data.widgetData.compareDateConfig.valueType.variationName) ? data.widgetData.compareDateConfig.valueType.variationName : "Variation", Validators.compose([Validators.pattern('^(?=.*[A-Za-z0-9])[\\S]*')])],
          differenceName: [(data.widgetData.compareDateConfig && data.widgetData.compareDateConfig.valueType && data.widgetData.compareDateConfig.valueType.differenceName) ? data.widgetData.compareDateConfig.valueType.differenceName : "Difference", Validators.compose([Validators.pattern('^(?=.*[A-Za-z0-9])[\\S]*')])],
        }),
        tableAggregator: this.fb.group({
          total: (data.widgetData.compareDateConfig && data.widgetData.compareDateConfig.tableAggregator && data.widgetData.compareDateConfig.tableAggregator.total == true) ? data.widgetData.compareDateConfig.tableAggregator.total : false,
          count: (data.widgetData.compareDateConfig && data.widgetData.compareDateConfig.tableAggregator && data.widgetData.compareDateConfig.tableAggregator.count == true) ? data.widgetData.compareDateConfig.tableAggregator.count : false,
          average: (data.widgetData.compareDateConfig && data.widgetData.compareDateConfig.tableAggregator && data.widgetData.compareDateConfig.tableAggregator.average == true) ? data.widgetData.compareDateConfig.tableAggregator.average : false,
          min: (data.widgetData.compareDateConfig && data.widgetData.compareDateConfig.tableAggregator && data.widgetData.compareDateConfig.tableAggregator.min == true) ? data.widgetData.compareDateConfig.tableAggregator.min : false,
          max: (data.widgetData.compareDateConfig && data.widgetData.compareDateConfig.tableAggregator && data.widgetData.compareDateConfig.tableAggregator.max == true) ? data.widgetData.compareDateConfig.tableAggregator.max : false,
          weekday: (data.widgetData.compareDateConfig && data.widgetData.compareDateConfig.tableAggregator && data.widgetData.compareDateConfig.tableAggregator.weekday == true) ? data.widgetData.compareDateConfig.tableAggregator.weekday : false,
          weekend: (data.widgetData.compareDateConfig && data.widgetData.compareDateConfig.tableAggregator && data.widgetData.compareDateConfig.tableAggregator.weekend == true) ? data.widgetData.compareDateConfig.tableAggregator.weekend : false,
        }),
        aggregatorNames: this.fb.group({
          totalName: [(data.widgetData.compareDateConfig && data.widgetData.compareDateConfig.aggregatorNames && data.widgetData.compareDateConfig.aggregatorNames.totalName) ? data.widgetData.compareDateConfig.aggregatorNames.totalName : 'Total', Validators.compose([Validators.pattern('^(?=.*[A-Za-z0-9])[\\S]*')])],
          countName: [(data.widgetData.compareDateConfig && data.widgetData.compareDateConfig.aggregatorNames && data.widgetData.compareDateConfig.aggregatorNames.countName) ? data.widgetData.compareDateConfig.aggregatorNames.countName : 'Count', Validators.compose([Validators.pattern('^(?=.*[A-Za-z0-9])[\\S]*')])],
          averageName: [(data.widgetData.compareDateConfig && data.widgetData.compareDateConfig.aggregatorNames && data.widgetData.compareDateConfig.aggregatorNames.averageName) ? data.widgetData.compareDateConfig.aggregatorNames.averageName : 'Average', Validators.compose([Validators.pattern('^(?=.*[A-Za-z0-9])[\\S]*')])],
          minName: [(data.widgetData.compareDateConfig && data.widgetData.compareDateConfig.aggregatorNames && data.widgetData.compareDateConfig.aggregatorNames.minName) ? data.widgetData.compareDateConfig.aggregatorNames.minName : 'Min', Validators.compose([Validators.pattern('^(?=.*[A-Za-z0-9])[\\S]*')])],
          maxName: [(data.widgetData.compareDateConfig && data.widgetData.compareDateConfig.aggregatorNames && data.widgetData.compareDateConfig.aggregatorNames.maxName) ? data.widgetData.compareDateConfig.aggregatorNames.maxName : 'Max', Validators.compose([Validators.pattern('^(?=.*[A-Za-z0-9])[\\S]*')])],
          weekdayName: [(data.widgetData.compareDateConfig && data.widgetData.compareDateConfig.aggregatorNames && data.widgetData.compareDateConfig.aggregatorNames.weekdayName) ? data.widgetData.compareDateConfig.aggregatorNames.weekdayName : 'Weekday', Validators.compose([Validators.pattern('^(?=.*[A-Za-z0-9])[\\S]*')])],
          weekendName: [(data.widgetData.compareDateConfig && data.widgetData.compareDateConfig.aggregatorNames && data.widgetData.compareDateConfig.aggregatorNames.weekendName) ? data.widgetData.compareDateConfig.aggregatorNames.weekendName : 'Weekend', Validators.compose([Validators.pattern('^(?=.*[A-Za-z0-9])[\\S]*')])]
        }),
        tableIndicator: this.fb.group({
          color: (data.widgetData.compareDateConfig && data.widgetData.compareDateConfig.tableIndicator && data.widgetData.compareDateConfig.tableIndicator.color == true) ? data.widgetData.compareDateConfig.tableIndicator.color : false,
          arrow: (data.widgetData.compareDateConfig && data.widgetData.compareDateConfig.tableIndicator && data.widgetData.compareDateConfig.tableIndicator.arrow == true) ? data.widgetData.compareDateConfig.tableIndicator.arrow : false,
        }),
        dayWeek: this.fb.group({
          monday: (data.widgetData.compareDateConfig && data.widgetData.compareDateConfig.dayWeek && data.widgetData.compareDateConfig.dayWeek.monday == false) ? data.widgetData.compareDateConfig.dayWeek.monday : true,
          tuesday: (data.widgetData.compareDateConfig && data.widgetData.compareDateConfig.dayWeek && data.widgetData.compareDateConfig.dayWeek.tuesday == false) ? data.widgetData.compareDateConfig.dayWeek.tuesday : true,
          wednesday: (data.widgetData.compareDateConfig && data.widgetData.compareDateConfig.dayWeek && data.widgetData.compareDateConfig.dayWeek.wednesday == false) ? data.widgetData.compareDateConfig.dayWeek.wednesday : true,
          thursday: (data.widgetData.compareDateConfig && data.widgetData.compareDateConfig.dayWeek && data.widgetData.compareDateConfig.dayWeek.thursday == false) ? data.widgetData.compareDateConfig.dayWeek.thursday : true,
          friday: (data.widgetData.compareDateConfig && data.widgetData.compareDateConfig.dayWeek && data.widgetData.compareDateConfig.dayWeek.friday == false) ? data.widgetData.compareDateConfig.dayWeek.friday : true,
          saturday: (data.widgetData.compareDateConfig && data.widgetData.compareDateConfig.dayWeek && data.widgetData.compareDateConfig.dayWeek.saturday == false) ? data.widgetData.compareDateConfig.dayWeek.saturday : true,
          sunday: (data.widgetData.compareDateConfig && data.widgetData.compareDateConfig.dayWeek && data.widgetData.compareDateConfig.dayWeek.sunday == false) ? data.widgetData.compareDateConfig.dayWeek.sunday : true,
        })
      }),
      countConfig: this.fb.group({
        formatNumber: data.widgetData.countConfig.formatNumber,
        boxColor: data.widgetData.countConfig.boxColor,
        valueColor: data.widgetData.countConfig.valueColor,
        labelColor: data.widgetData.countConfig.labelColor,
        borderThickness: data.widgetData.countConfig.borderThickness,
        borderColor: data.widgetData.countConfig.borderColor,
        // isTrendE:data.widgetData.countConfig.isTrendE,
        // trendColor:data.widgetData.countConfig.trendColor
      }),
      trendConfig: this.fb.group({
        isTrendBar: data.widgetData.trendConfig.isTrendBar,
        isCurrent: data.widgetData.trendConfig.isCurrent,
        isPastD: data.widgetData.trendConfig.isPastD,
        isPastW: data.widgetData.trendConfig.isPastW,
        isPastM: data.widgetData.trendConfig.isPastM,
        isPastY: data.widgetData.trendConfig.isPastY,
        boxColor: data.widgetData.trendConfig.boxColor,
        valueColor: data.widgetData.trendConfig.valueColor
      }),
      numericConfig: this.fb.group({
        // chartLabelSettings:data.widgetData.numericConfig.TopOrBottom,
        // NoOfPerformers: data.widgetData.numericConfig.NoOfPerformers,
        // chartLabelFontSize: data.widgetData.numericConfig.chartLabelFontSize,
        // chartLabelDecimals: data.widgetData.numericConfig.chartLabelDecimals,
        // chartLabelAlignment: data.widgetData.numericConfig.chartLabelAlignment,
        // chartLabelColor: data.widgetData.numericConfig.chartLabelColor,
        // xPositionOffset: data.widgetData.numericConfig.xPositionOffset,
        // yPositionOffset: data.widgetData.numericConfig.yPositionOffset,
        // allowOverlap:data.widgetData.numericConfig.allowOverlap,
        // crop:data.widgetData.numericConfig.crop
      }),
      performerConfig: this.fb.group({
        topOrBottom: data.widgetData.performerConfig.topOrBottom,
        noOfPerformers: data.widgetData.performerConfig.noOfPerformers
      }),
      visualConfig: this.fb.group({
        isMultiSensor: data.widgetData.visualConfig.isMultiSensor
      }),
      axisConfig: this.fb.group({
        y1: this.fb.group({
          label: data.widgetData.axisConfig.y1.label,
          decimals: data.widgetData.axisConfig.y1.decimals,
        }),
        y2: this.fb.group({
          label: data.widgetData.axisConfig.y2.label,
          decimals: data.widgetData.axisConfig.y2.decimals,
        })
      }),
      histogramConfig: this.fb.group({
        rangeType: data.widgetData.histogramConfig.rangeType,
        valueType: data.widgetData.histogramConfig.valueType,
        bins: data.widgetData.histogramConfig.bins
      }),
      widgetConfig: this.fb.group({
        width: [((data.widgetData.widgetConfig && data.widgetData.widgetConfig.width) ? data.widgetData.widgetConfig.width : this.defaultWidth ? this.defaultWidth[data.widgetData.kpiType] : 50), Validators.compose([Validators.required, Validators.pattern('^[2-9][0-9]?$|^100$')])],
      }),
      isRowTotal: data.widgetData.hasOwnProperty('isRowTotal') ? data.widgetData.isRowTotal : true,
      isColumnTotal: data.widgetData.hasOwnProperty('isColumnTotal') ? data.widgetData.isColumnTotal : true,
      isAdjustHeader: data.widgetData.hasOwnProperty('isAdjustHeader') ? data.widgetData.isAdjustHeader : false,
      dateType: data.widgetData.dateType,
      from: data.widgetData.from,
      to: data.widgetData.to,
      image: data.widgetData.image,
      displayType: data.widgetData.displayType,
      imageName: data.widgetData.imageName,
      kpiType: [data.widgetData.kpiType, Validators.required],
      fetchDataFor: data.widgetData.fetchDataFor,
      dataFilter: this.fb.array([]),
      binFilter: this.fb.array([]),
      isEffectedByGroupFilter: data.widgetData.isEffectedByGroupFilter,
      hideBackGround: data.widgetData.hideBackGround,
      hideTitle: data.widgetData.hideTitle,
      hideBorder: data.widgetData.hideBorder
    });
    if (data.widgetData && data.widgetData._id) {
      this.setDataFilter(data.widgetData.dataFilter);
      if (data.widgetData.binFilter.length > 0)
        this.setHistogramFilter(data.widgetData.binFilter);
    }
    this.chartForm.get('kpiType').valueChanges.pipe(takeUntil(this._onDestroy)).subscribe((type: string) => {
      if (type === 'histogram') {
        this.chartForm.get('histogramConfig').get('rangeType').clearValidators();
        this.chartForm.get('histogramConfig').get('valueType').clearValidators();
        this.chartForm.get('histogramConfig').get('bins').clearValidators();
        this.chartForm.get('histogramConfig').get('rangeType').setValidators([Validators.required]);
        this.chartForm.get('histogramConfig').get('valueType').setValidators([Validators.required]);
        this.chartForm.get('histogramConfig').get('bins').setValidators([Validators.required, Validators.pattern("^[0-9]*$"), Validators.min(1)]);
      } else {
        this.chartForm.get('histogramConfig').get('rangeType').clearValidators();
        this.chartForm.get('histogramConfig').get('valueType').clearValidators();
        this.chartForm.get('histogramConfig').get('bins').clearValidators();
      }
      if (type === 'comparison') {
        this.chartForm.get('compareConfig').get('compareType').setValidators([Validators.required]);
      } else {
        this.chartForm.get('compareConfig').get('fetchDataFor').patchValue('');
        this.chartForm.get('compareConfig').get('compareType').patchValue('');
        this.chartForm.get('compareConfig').get('compareType').clearValidators();
        this.chartForm.get('compareConfig').get('fromDate').clearValidators();
        this.chartForm.get('compareConfig').get('toDate').clearValidators();
      }
      if(type == 'compareDate'){
        this.chartForm.get('compareDateConfig').get('compareType').setValidators([Validators.required]);
        this.chartForm.get('compareDateConfig').get('fetchDataFor').patchValue('table');
      }else{
        this.chartForm.get('compareDateConfig').get('fetchDataFor').patchValue('');
        this.chartForm.get('compareDateConfig').get('compareType').patchValue('');
        this.chartForm.get('compareDateConfig').get('fromDate').patchValue('');
        this.chartForm.get('compareDateConfig').get('toDate').patchValue('');
        this.chartForm.get('compareDateConfig').get('compareType').clearValidators();
        this.chartForm.get('compareDateConfig').get('fromDate').clearValidators();
        this.chartForm.get('compareDateConfig').get('toDate').clearValidators();
      }
      this.chartForm.get('compareDateConfig').get('compareType').updateValueAndValidity();
      this.chartForm.get('compareDateConfig').get('fromDate').updateValueAndValidity();
      this.chartForm.get('compareDateConfig').get('toDate').updateValueAndValidity();
      
      this.chartForm.get('compareConfig').get('compareType').updateValueAndValidity();
      this.chartForm.get('compareConfig').get('fromDate').updateValueAndValidity();
      this.chartForm.get('compareConfig').get('toDate').updateValueAndValidity();

      this.chartForm.get('histogramConfig').get('rangeType').updateValueAndValidity();
      this.chartForm.get('histogramConfig').get('valueType').updateValueAndValidity();
      this.chartForm.get('histogramConfig').get('bins').updateValueAndValidity();
    });
    this.chartForm.get('histogramConfig').get('rangeType').valueChanges.pipe(takeUntil(this._onDestroy)).subscribe((range: string) => {
      if (range === 'integer') {
        this.chartForm.get('histogramConfig').get('valueType').setValue('absolute');
      }
    });
    this.chartForm.get('compareConfig').get('compareType').valueChanges.pipe(takeUntil(this._onDestroy)).subscribe((type: string) => {
      this.chartForm.get('compareConfig').get('fromDate').patchValue('');
      this.chartForm.get('compareConfig').get('toDate').patchValue('');
      this.chartForm.get('compareConfig').get('eventId').patchValue('');
      this.chartForm.get('compareConfig').get('displayName').patchValue('');
      if (type === 'dateRanges' || type === 'events' || type === 'periodOver') {
        this.chartForm.get('compareConfig').get('displayName').setValidators([Validators.required]);
        if (type === 'dateRanges') {
          this.chartForm.get('compareConfig').get('fromDate').setValidators([Validators.required]);
          this.chartForm.get('compareConfig').get('toDate').setValidators([Validators.required]);
          this.chartForm.get('compareConfig').get('displayName').patchValue('Selected Period');
          this.chartForm.get('compareConfig').get('eventId').clearValidators();
        }
        if (type === 'events' || type === 'periodOver') {
          if (type === 'periodOver')
            this.chartForm.get('compareConfig').get('displayName').patchValue('Selected Period');
          else
            this.chartForm.get('compareConfig').get('displayName').patchValue('');
          this.chartForm.get('compareConfig').get('eventId').setValidators([Validators.required]);
          this.chartForm.get('compareConfig').get('fromDate').clearValidators();
          this.chartForm.get('compareConfig').get('toDate').clearValidators();
        }
      } else {
        this.chartForm.get('compareConfig').get('displayName').clearValidators();
        this.chartForm.get('compareConfig').get('fromDate').clearValidators();
        this.chartForm.get('compareConfig').get('toDate').clearValidators();
        this.chartForm.get('compareConfig').get('eventId').clearValidators();
      }
      this.chartForm.get('compareConfig').get('displayName').updateValueAndValidity();
      this.chartForm.get('compareConfig').get('fromDate').updateValueAndValidity();
      this.chartForm.get('compareConfig').get('toDate').updateValueAndValidity();
      this.chartForm.get('compareConfig').get('eventId').updateValueAndValidity();
      this.chartForm.get('compareConfig').get('range1').get('fromDate').patchValue('');
      this.chartForm.get('compareConfig').get('range1').get('toDate').patchValue('');
      this.chartForm.get('compareConfig').get('range1').get('eventId').patchValue('');
      this.chartForm.get('compareConfig').get('range1').get('enabled').patchValue(false);
      this.chartForm.get('compareConfig').get('range1').get('displayName').patchValue('');
      this.chartForm.get('compareConfig').get('range2').get('fromDate').patchValue('');
      this.chartForm.get('compareConfig').get('range2').get('toDate').patchValue('');
      this.chartForm.get('compareConfig').get('range2').get('eventId').patchValue('');
      this.chartForm.get('compareConfig').get('range2').get('enabled').patchValue(false);
      this.chartForm.get('compareConfig').get('range2').get('displayName').patchValue('');
      this.chartForm.get('compareConfig').get('range3').get('fromDate').patchValue('');
      this.chartForm.get('compareConfig').get('range3').get('toDate').patchValue('');
      this.chartForm.get('compareConfig').get('range3').get('eventId').patchValue('');
      this.chartForm.get('compareConfig').get('range3').get('enabled').patchValue(false);
      this.chartForm.get('compareConfig').get('range3').get('displayName').patchValue('');
      this.chartForm.get('compareConfig').get('range4').get('fromDate').patchValue('');
      this.chartForm.get('compareConfig').get('range4').get('toDate').patchValue('');
      this.chartForm.get('compareConfig').get('range4').get('eventId').patchValue('');
      this.chartForm.get('compareConfig').get('range4').get('enabled').patchValue(false);
      this.chartForm.get('compareConfig').get('range4').get('displayName').patchValue('');
      this.chartForm.get('compareConfig').get('range5').get('fromDate').patchValue('');
      this.chartForm.get('compareConfig').get('range5').get('toDate').patchValue('');
      this.chartForm.get('compareConfig').get('range5').get('eventId').patchValue('');
      this.chartForm.get('compareConfig').get('range5').get('enabled').patchValue(false);
      this.chartForm.get('compareConfig').get('range5').get('displayName').patchValue('');

      this.chartForm.get('compareConfig').get('weekDays').get('monday').patchValue(true);
      this.chartForm.get('compareConfig').get('weekDays').get('tuesday').patchValue(true);
      this.chartForm.get('compareConfig').get('weekDays').get('wednesday').patchValue(true);
      this.chartForm.get('compareConfig').get('weekDays').get('thursday').patchValue(true);
      this.chartForm.get('compareConfig').get('weekDays').get('friday').patchValue(true);
      this.chartForm.get('compareConfig').get('weekDays').get('saturday').patchValue(true);
      this.chartForm.get('compareConfig').get('weekDays').get('sunday').patchValue(true);

      this.chartForm.get('compareConfig').get('dayWeek').get('monday').patchValue(true);
      this.chartForm.get('compareConfig').get('dayWeek').get('tuesday').patchValue(true);
      this.chartForm.get('compareConfig').get('dayWeek').get('wednesday').patchValue(true);
      this.chartForm.get('compareConfig').get('dayWeek').get('thursday').patchValue(true);
      this.chartForm.get('compareConfig').get('dayWeek').get('friday').patchValue(true);
      this.chartForm.get('compareConfig').get('dayWeek').get('saturday').patchValue(true);
      this.chartForm.get('compareConfig').get('dayWeek').get('sunday').patchValue(true);

      this.chartForm.get('compareConfig').get('displayRange').patchValue('selected');
      this.chartForm.get('compareConfig').get('segregateDate').patchValue('dates');
      this.chartForm.get('compareConfig').get('segregateName').patchValue('Dates');

      this.chartForm.get('compareConfig').get('tableAggregator').get('total').patchValue(false);
      this.chartForm.get('compareConfig').get('tableAggregator').get('count').patchValue(false);
      this.chartForm.get('compareConfig').get('tableAggregator').get('average').patchValue(false);
      this.chartForm.get('compareConfig').get('tableAggregator').get('min').patchValue(false);
      this.chartForm.get('compareConfig').get('tableAggregator').get('max').patchValue(false);
      this.chartForm.get('compareConfig').get('aggregatorNames').get('totalName').patchValue('Total');
      this.chartForm.get('compareConfig').get('aggregatorNames').get('countName').patchValue('Count');
      this.chartForm.get('compareConfig').get('aggregatorNames').get('averageName').patchValue('Average');
      this.chartForm.get('compareConfig').get('aggregatorNames').get('minName').patchValue('Min');
      this.chartForm.get('compareConfig').get('aggregatorNames').get('maxName').patchValue('Max');

      this.chartForm.get('compareConfig').get('tableIndicator').get('color').patchValue(false);
      this.chartForm.get('compareConfig').get('tableIndicator').get('arrow').patchValue(false);

      this.chartForm.get('compareConfig').get('valueType').get('Value').patchValue(true);
      this.chartForm.get('compareConfig').get('valueType').get('Variation').patchValue(false);
      this.chartForm.get('compareConfig').get('valueType').get('Difference').patchValue(false);

      this.chartForm.get('compareConfig').get('tableAdjust').get('tableHeight').patchValue(false);
      this.chartForm.get('compareConfig').get('tableAdjust').get('tableWidth').patchValue(false);
      this.chartForm.get('compareConfig').get('tableAdjust').get('tableRows').patchValue('');
      this.chartForm.get('compareConfig').get('tableAdjust').get('tableHeader').patchValue(false);

    });
    this.chartForm.get('compareConfig').get('eventId').valueChanges.pipe(takeUntil(this._onDestroy)).subscribe((type: string) => {
      if (type === 'Custom' && this.chartForm.get('compareConfig').get('compareType').value == 'periodOver') {
        this.chartForm.get('compareConfig').get('fromDate').setValidators([Validators.required]);
        this.chartForm.get('compareConfig').get('toDate').setValidators([Validators.required]);
      } else {
        this.chartForm.get('compareConfig').get('fromDate').clearValidators();
        this.chartForm.get('compareConfig').get('toDate').clearValidators();
      }
      this.chartForm.get('compareConfig').get('fromDate').updateValueAndValidity();
      this.chartForm.get('compareConfig').get('toDate').updateValueAndValidity();
      if(!['Today','Yesterday'].includes(type)){
        this.chartForm.get('compareConfig').get('differenceTiming').get('day').patchValue(false);
        this.chartForm.get('compareConfig').get('differenceTiming').get('date').patchValue(false);
      }
    });
    this.chartForm.get('compareConfig').get('range1').get('enabled').valueChanges.pipe(takeUntil(this._onDestroy)).subscribe((type: boolean) => {
      if (type === true) {
        this.chartForm.get('compareConfig').get('range1').get('displayName').setValidators([Validators.required]);
        if (this.chartForm.get('compareConfig').get('compareType').value === 'dateRanges') {
          this.chartForm.get('compareConfig').get('range1').get('fromDate').setValidators([Validators.required]);
          this.chartForm.get('compareConfig').get('range1').get('toDate').setValidators([Validators.required]);
          this.chartForm.get('compareConfig').get('range1').get('displayName').patchValue('Compare Period 1');
        } else if (this.chartForm.get('compareConfig').get('compareType').value === 'events') {
          this.chartForm.get('compareConfig').get('range1').get('eventId').setValidators([Validators.required]);
          this.chartForm.get('compareConfig').get('range1').get('displayName').patchValue('');
        } else if (this.chartForm.get('compareConfig').get('compareType').value === 'periodOver') {
          this.chartForm.get('compareConfig').get('range1').get('displayName').patchValue('Previous Day');
        }
      } else {
        if (this.chartForm.get('compareConfig').get('compareType').value === 'dateRanges') {
          this.chartForm.get('compareConfig').get('range1').get('fromDate').patchValue('');
          this.chartForm.get('compareConfig').get('range1').get('toDate').patchValue('');
          this.chartForm.get('compareConfig').get('range1').get('fromDate').clearValidators();
          this.chartForm.get('compareConfig').get('range1').get('toDate').clearValidators();
          this.chartForm.get('compareConfig').get('range1').get('fromDate').updateValueAndValidity();
          this.chartForm.get('compareConfig').get('range1').get('toDate').updateValueAndValidity();
        } else if (this.chartForm.get('compareConfig').get('compareType').value === 'events') {
          this.eventList.filter(function (el) {
            if (el.type === 'range1') {
              el.isSelected = false;
              el.type = ""
            }
          });
          this.chartForm.get('compareConfig').get('range1').get('eventId').patchValue('');
          this.chartForm.get('compareConfig').get('range1').get('eventId').clearValidators();
          this.chartForm.get('compareConfig').get('range1').get('eventId').updateValueAndValidity();
        }
        this.chartForm.get('compareConfig').get('range1').get('displayName').clearValidators();
      }
      this.chartForm.get('compareConfig').get('range1').get('displayName').updateValueAndValidity();
    });
    this.chartForm.get('compareConfig').get('range2').get('enabled').valueChanges.pipe(takeUntil(this._onDestroy)).subscribe((type: boolean) => {
      if (type === true) {
        this.chartForm.get('compareConfig').get('range2').get('displayName').setValidators([Validators.required]);
        if (this.chartForm.get('compareConfig').get('compareType').value === 'dateRanges') {
          this.chartForm.get('compareConfig').get('range2').get('fromDate').setValidators([Validators.required]);
          this.chartForm.get('compareConfig').get('range2').get('toDate').setValidators([Validators.required]);
          this.chartForm.get('compareConfig').get('range2').get('displayName').patchValue('Compare Period 2');
        } else if (this.chartForm.get('compareConfig').get('compareType').value === 'events') {
          this.chartForm.get('compareConfig').get('range2').get('eventId').setValidators([Validators.required]);
          this.chartForm.get('compareConfig').get('range2').get('displayName').patchValue('');
        } else if (this.chartForm.get('compareConfig').get('compareType').value === 'periodOver') {
          this.chartForm.get('compareConfig').get('range2').get('displayName').patchValue('Previous Week');
        }
      } else {
        if (this.chartForm.get('compareConfig').get('compareType').value === 'dateRanges') {
          this.chartForm.get('compareConfig').get('range2').get('fromDate').patchValue('');
          this.chartForm.get('compareConfig').get('range2').get('toDate').patchValue('');
          this.chartForm.get('compareConfig').get('range2').get('fromDate').clearValidators();
          this.chartForm.get('compareConfig').get('range2').get('toDate').clearValidators();
        }
        else if (this.chartForm.get('compareConfig').get('compareType').value === 'events') {
          this.eventList.filter(function (el) {
            if (el.type === 'range2') {
              el.isSelected = false;
              el.type = ""
            }
          });
          this.chartForm.get('compareConfig').get('range2').get('eventId').patchValue('');
          this.chartForm.get('compareConfig').get('range2').get('eventId').clearValidators();
          this.chartForm.get('compareConfig').get('range2').get('eventId').updateValueAndValidity();
        }
        this.chartForm.get('compareConfig').get('range2').get('displayName').clearValidators();
      }
      this.chartForm.get('compareConfig').get('range2').get('displayName').updateValueAndValidity();
      this.chartForm.get('compareConfig').get('range2').get('fromDate').updateValueAndValidity();
      this.chartForm.get('compareConfig').get('range2').get('toDate').updateValueAndValidity();
    });
    this.chartForm.get('compareConfig').get('range3').get('enabled').valueChanges.pipe(takeUntil(this._onDestroy)).subscribe((type: boolean) => {
      if (type === true) {
        this.chartForm.get('compareConfig').get('range3').get('displayName').setValidators([Validators.required]);
        if (this.chartForm.get('compareConfig').get('compareType').value === 'dateRanges') {
          this.chartForm.get('compareConfig').get('range3').get('fromDate').setValidators([Validators.required]);
          this.chartForm.get('compareConfig').get('range3').get('toDate').setValidators([Validators.required]);
          this.chartForm.get('compareConfig').get('range3').get('displayName').patchValue('Compare Period 3');
        } else if (this.chartForm.get('compareConfig').get('compareType').value === 'events') {
          this.chartForm.get('compareConfig').get('range3').get('eventId').setValidators([Validators.required]);
          this.chartForm.get('compareConfig').get('range3').get('displayName').patchValue('');
        } else if (this.chartForm.get('compareConfig').get('compareType').value === 'periodOver') {
          this.chartForm.get('compareConfig').get('range3').get('displayName').patchValue('Previous Month');
        }
      } else {
        if (this.chartForm.get('compareConfig').get('compareType').value === 'dateRanges') {
          this.chartForm.get('compareConfig').get('range3').get('fromDate').patchValue('');
          this.chartForm.get('compareConfig').get('range3').get('toDate').patchValue('');
          this.chartForm.get('compareConfig').get('range3').get('fromDate').clearValidators();
          this.chartForm.get('compareConfig').get('range3').get('toDate').clearValidators();
        } else if (this.chartForm.get('compareConfig').get('compareType').value === 'events') {
          this.eventList.filter(function (el) {
            if (el.type === 'range3') {
              el.isSelected = false;
              el.type = ""
            }
          });
          this.chartForm.get('compareConfig').get('range3').get('eventId').patchValue('');
          this.chartForm.get('compareConfig').get('range3').get('eventId').clearValidators();
          this.chartForm.get('compareConfig').get('range3').get('eventId').updateValueAndValidity();
        }
        this.chartForm.get('compareConfig').get('range3').get('displayName').clearValidators();
      }
      this.chartForm.get('compareConfig').get('range3').get('displayName').updateValueAndValidity();
      this.chartForm.get('compareConfig').get('range3').get('fromDate').updateValueAndValidity();
      this.chartForm.get('compareConfig').get('range3').get('toDate').updateValueAndValidity();
    });
    this.chartForm.get('compareConfig').get('range4').get('enabled').valueChanges.pipe(takeUntil(this._onDestroy)).subscribe((type: boolean) => {
      if (type === true) {
        this.chartForm.get('compareConfig').get('range4').get('displayName').setValidators([Validators.required]);
        if (this.chartForm.get('compareConfig').get('compareType').value === 'dateRanges') {
          this.chartForm.get('compareConfig').get('range4').get('fromDate').setValidators([Validators.required]);
          this.chartForm.get('compareConfig').get('range4').get('toDate').setValidators([Validators.required]);
          this.chartForm.get('compareConfig').get('range4').get('displayName').patchValue('Compare Period 4');
        } else if (this.chartForm.get('compareConfig').get('compareType').value === 'events') {
          this.chartForm.get('compareConfig').get('range4').get('eventId').setValidators([Validators.required]);
          this.chartForm.get('compareConfig').get('range4').get('displayName').patchValue('');
        } else if (this.chartForm.get('compareConfig').get('compareType').value === 'periodOver') {
          this.chartForm.get('compareConfig').get('range4').get('displayName').patchValue('Previous Year');
        }
      } else {
        if (this.chartForm.get('compareConfig').get('compareType').value === 'dateRanges') {
          this.chartForm.get('compareConfig').get('range4').get('fromDate').patchValue('');
          this.chartForm.get('compareConfig').get('range4').get('toDate').patchValue('');
          this.chartForm.get('compareConfig').get('range4').get('fromDate').clearValidators();
          this.chartForm.get('compareConfig').get('range4').get('toDate').clearValidators();
        } else if (this.chartForm.get('compareConfig').get('compareType').value === 'events') {
          this.eventList.filter(function (el) {
            if (el.type === 'range4') {
              el.isSelected = false;
              el.type = ""
            }
          });
          this.chartForm.get('compareConfig').get('range4').get('eventId').patchValue('');
          this.chartForm.get('compareConfig').get('range4').get('eventId').clearValidators();
          this.chartForm.get('compareConfig').get('range4').get('eventId').updateValueAndValidity();
        }
        this.chartForm.get('compareConfig').get('range4').get('displayName').clearValidators();
      }
      this.chartForm.get('compareConfig').get('range4').get('displayName').updateValueAndValidity();
      this.chartForm.get('compareConfig').get('range4').get('fromDate').updateValueAndValidity();
      this.chartForm.get('compareConfig').get('range4').get('toDate').updateValueAndValidity();
    });
    this.chartForm.get('compareConfig').get('range5').get('enabled').valueChanges.pipe(takeUntil(this._onDestroy)).subscribe((type: boolean) => {
      if (type === true) {
        this.chartForm.get('compareConfig').get('range5').get('displayName').setValidators([Validators.required]);
        if (this.chartForm.get('compareConfig').get('compareType').value === 'dateRanges') {
          this.chartForm.get('compareConfig').get('range5').get('fromDate').setValidators([Validators.required]);
          this.chartForm.get('compareConfig').get('range5').get('toDate').setValidators([Validators.required]);
          this.chartForm.get('compareConfig').get('range5').get('displayName').patchValue('Compare Period 5');
        } else if (this.chartForm.get('compareConfig').get('compareType').value === 'events') {
          this.chartForm.get('compareConfig').get('range5').get('eventId').setValidators([Validators.required]);
          this.chartForm.get('compareConfig').get('range5').get('displayName').patchValue('');
        } else if (this.chartForm.get('compareConfig').get('compareType').value === 'periodOver') {
          this.chartForm.get('compareConfig').get('range5').get('displayName').patchValue('Year Before Previous Year');
        }
      } else {
        if (this.chartForm.get('compareConfig').get('compareType').value === 'dateRanges') {
          this.chartForm.get('compareConfig').get('range5').get('fromDate').patchValue('');
          this.chartForm.get('compareConfig').get('range5').get('toDate').patchValue('');
          this.chartForm.get('compareConfig').get('range5').get('fromDate').clearValidators();
          this.chartForm.get('compareConfig').get('range5').get('toDate').clearValidators();
        } else if (this.chartForm.get('compareConfig').get('compareType').value === 'events') {
          this.eventList.filter(function (el) {
            if (el.type === 'range5') {
              el.isSelected = false;
              el.type = ""
            }
          });
          this.chartForm.get('compareConfig').get('range5').get('eventId').patchValue('');
          this.chartForm.get('compareConfig').get('range5').get('eventId').clearValidators();
          this.chartForm.get('compareConfig').get('range5').get('eventId').updateValueAndValidity();
        }
        this.chartForm.get('compareConfig').get('range5').get('displayName').clearValidators();
      }
      this.chartForm.get('compareConfig').get('range5').get('displayName').updateValueAndValidity();
      this.chartForm.get('compareConfig').get('range5').get('fromDate').updateValueAndValidity();
      this.chartForm.get('compareConfig').get('range5').get('toDate').updateValueAndValidity();
    });
    this.chartForm.get('compareConfig').get('tableAdjust').get('tableHeight').valueChanges.pipe(takeUntil(this._onDestroy)).subscribe((type: boolean) => {
      if (type === false) {
        this.chartForm.get('compareConfig').get('tableAdjust').get('tableRows').patchValue('');
      }
    });
    this.chartForm.get('compareConfig').get('segregateDate').valueChanges.pipe(takeUntil(this._onDestroy)).subscribe((type: string) => {
      if (type != '')
        this.chartForm.get('compareConfig').get('segregateName').patchValue(type.charAt(0).toUpperCase() + type.slice(1));
    });
    this.chartForm.get('compareConfig').get('tableAggregator').get('total').valueChanges.pipe(takeUntil(this._onDestroy)).subscribe((type: boolean) => {
      if (type === true)
        this.chartForm.get('compareConfig').get('aggregatorNames').get('totalName').patchValue('Total');
    });
    this.chartForm.get('compareConfig').get('tableAggregator').get('count').valueChanges.pipe(takeUntil(this._onDestroy)).subscribe((type: boolean) => {
      if (type === true)
        this.chartForm.get('compareConfig').get('aggregatorNames').get('countName').patchValue('Count');
    });
    this.chartForm.get('compareConfig').get('tableAggregator').get('average').valueChanges.pipe(takeUntil(this._onDestroy)).subscribe((type: boolean) => {
      if (type === true)
        this.chartForm.get('compareConfig').get('aggregatorNames').get('averageName').patchValue('Average');
    });
    this.chartForm.get('compareConfig').get('tableAggregator').get('min').valueChanges.pipe(takeUntil(this._onDestroy)).subscribe((type: boolean) => {
      if (type === true)
        this.chartForm.get('compareConfig').get('aggregatorNames').get('minName').patchValue('Min');
    });
    this.chartForm.get('compareConfig').get('tableAggregator').get('max').valueChanges.pipe(takeUntil(this._onDestroy)).subscribe((type: boolean) => {
      if (type === true)
        this.chartForm.get('compareConfig').get('aggregatorNames').get('maxName').patchValue('Max');
    });

    this.chartForm.get('compareDateConfig').get('tableAggregator').get('total').valueChanges.pipe(takeUntil(this._onDestroy)).subscribe((type: boolean) => {
      if (type === true)
        this.chartForm.get('compareDateConfig').get('aggregatorNames').get('totalName').patchValue('Total');
    });
    this.chartForm.get('compareDateConfig').get('tableAggregator').get('count').valueChanges.pipe(takeUntil(this._onDestroy)).subscribe((type: boolean) => {
      if (type === true)
        this.chartForm.get('compareDateConfig').get('aggregatorNames').get('countName').patchValue('Count');
    });
    this.chartForm.get('compareDateConfig').get('tableAggregator').get('average').valueChanges.pipe(takeUntil(this._onDestroy)).subscribe((type: boolean) => {
      if (type === true)
        this.chartForm.get('compareDateConfig').get('aggregatorNames').get('averageName').patchValue('Average');
    });
    this.chartForm.get('compareDateConfig').get('tableAggregator').get('min').valueChanges.pipe(takeUntil(this._onDestroy)).subscribe((type: boolean) => {
      if (type === true)
        this.chartForm.get('compareDateConfig').get('aggregatorNames').get('minName').patchValue('Min');
    });
    this.chartForm.get('compareDateConfig').get('tableAggregator').get('max').valueChanges.pipe(takeUntil(this._onDestroy)).subscribe((type: boolean) => {
      if (type === true)
        this.chartForm.get('compareDateConfig').get('aggregatorNames').get('maxName').patchValue('Max');
    });
    this.chartForm.get('compareDateConfig').get('tableAggregator').get('weekday').valueChanges.pipe(takeUntil(this._onDestroy)).subscribe((type: boolean) => {
      if (type === true)
        this.chartForm.get('compareDateConfig').get('aggregatorNames').get('weekdayName').patchValue('Weekday');
    });
    this.chartForm.get('compareDateConfig').get('tableAggregator').get('weekend').valueChanges.pipe(takeUntil(this._onDestroy)).subscribe((type: boolean) => {
      if (type === true)
        this.chartForm.get('compareDateConfig').get('aggregatorNames').get('weekendName').patchValue('Weekend');
    });

    this.chartForm.get('compareDateConfig').get('compareType').valueChanges.pipe(takeUntil(this._onDestroy)).subscribe((type: string) => {
      this.chartForm.get('compareDateConfig').get('fromDate').patchValue('');
      this.chartForm.get('compareDateConfig').get('toDate').patchValue('');
      this.isSelected = false;
      if(type == 'daily'){
        this.chartForm.get('compareDateConfig').get('fromDate').setValidators([Validators.required]);
        this.chartForm.get('compareDateConfig').get('toDate').setValidators([Validators.required]);
        this.chartForm.get('compareDateConfig').get('dateType').patchValue('customDate');
      }else{
        this.chartForm.get('compareDateConfig').get('fromDate').clearValidators();
        this.chartForm.get('compareDateConfig').get('toDate').clearValidators();
      }
      this.chartForm.get('compareDateConfig').get('fromDate').updateValueAndValidity();
      this.chartForm.get('compareDateConfig').get('toDate').updateValueAndValidity();

      this.chartForm.get('compareDateConfig').get('fromDate').patchValue('');
      this.chartForm.get('compareDateConfig').get('toDate').patchValue('');
      this.chartForm.get('compareDateConfig').get('date1').get('enabled').patchValue(false);
      this.chartForm.get('compareDateConfig').get('date1').get('displayName').patchValue('');
      this.chartForm.get('compareDateConfig').get('date2').get('enabled').patchValue(false);
      this.chartForm.get('compareDateConfig').get('date2').get('displayName').patchValue('');
      this.chartForm.get('compareDateConfig').get('date3').get('enabled').patchValue(false);
      this.chartForm.get('compareDateConfig').get('date3').get('displayName').patchValue('');
      this.chartForm.get('compareDateConfig').get('date4').get('enabled').patchValue(false);
      this.chartForm.get('compareDateConfig').get('date4').get('displayName').patchValue('');

      this.chartForm.get('compareDateConfig').get('valueType').get('lastYear').patchValue(false);
      this.chartForm.get('compareDateConfig').get('valueType').get('Variation').patchValue(false);
      this.chartForm.get('compareDateConfig').get('valueType').get('variationName').patchValue('Variation');
      this.chartForm.get('compareDateConfig').get('valueType').get('Difference').patchValue(false);
      this.chartForm.get('compareDateConfig').get('valueType').get('differenceName').patchValue('Difference');

      this.chartForm.get('compareDateConfig').get('tableIndicator').get('color').patchValue(false);
      this.chartForm.get('compareDateConfig').get('tableIndicator').get('arrow').patchValue(false);

      this.chartForm.get('compareDateConfig').get('tableAggregator').get('total').patchValue(false);
      this.chartForm.get('compareDateConfig').get('tableAggregator').get('count').patchValue(false);
      this.chartForm.get('compareDateConfig').get('tableAggregator').get('average').patchValue(false);
      this.chartForm.get('compareDateConfig').get('tableAggregator').get('min').patchValue(false);
      this.chartForm.get('compareDateConfig').get('tableAggregator').get('max').patchValue(false);
      this.chartForm.get('compareDateConfig').get('tableAggregator').get('weekend').patchValue(false);
      this.chartForm.get('compareDateConfig').get('tableAggregator').get('weekday').patchValue(false);
      this.chartForm.get('compareDateConfig').get('aggregatorNames').get('totalName').patchValue('Total');
      this.chartForm.get('compareDateConfig').get('aggregatorNames').get('countName').patchValue('Count');
      this.chartForm.get('compareDateConfig').get('aggregatorNames').get('averageName').patchValue('Average');
      this.chartForm.get('compareDateConfig').get('aggregatorNames').get('minName').patchValue('Min');
      this.chartForm.get('compareDateConfig').get('aggregatorNames').get('maxName').patchValue('Max');
      this.chartForm.get('compareDateConfig').get('aggregatorNames').get('weekendName').patchValue('Weekend');
      this.chartForm.get('compareDateConfig').get('aggregatorNames').get('weekdayName').patchValue('Weekday');
    });

    this.chartForm.get('compareDateConfig').get('dateType').valueChanges.pipe(takeUntil(this._onDestroy)).subscribe((type:string)=>{
      if(type == 'customDate'){
        this.chartForm.get('compareDateConfig').get('fromDate').setValidators([Validators.required]);
        this.chartForm.get('compareDateConfig').get('toDate').setValidators([Validators.required]);
      }
      if(type == 'monthTillDate' || type == 'monthTillLastDate'){
        this.chartForm.get('compareDateConfig').get('fromDate').patchValue('');
        this.chartForm.get('compareDateConfig').get('toDate').patchValue('');
        this.chartForm.get('compareDateConfig').get('fromDate').clearValidators();
        this.chartForm.get('compareDateConfig').get('toDate').clearValidators();
      }
      this.chartForm.get('compareDateConfig').get('fromDate').updateValueAndValidity();
      this.chartForm.get('compareDateConfig').get('toDate').updateValueAndValidity();
    })
  }

  checkDisplayName(val: any, type: any) {
    this.displayMessage = "";
    if (val != '') {
      if (type != 'range0' && this.chartForm.get('compareConfig').get('displayName').value == val)
        this.displayMessage = type;
      if (type != 'range1' && this.chartForm.get('compareConfig').get('range1').get('displayName').value == val)
        this.displayMessage = type;
      if (type != 'range2' && this.chartForm.get('compareConfig').get('range2').get('displayName').value == val)
        this.displayMessage = type;
      if (type != 'range3' && this.chartForm.get('compareConfig').get('range3').get('displayName').value == val)
        this.displayMessage = type;
      if (type != 'range4' && this.chartForm.get('compareConfig').get('range4').get('displayName').value == val)
        this.displayMessage = type;
      if (type != 'range5' && this.chartForm.get('compareConfig').get('range5').get('displayName').value == val)
        this.displayMessage = type;
    }
  }

  setDisplayName(rType: any) {
    if (this.chartForm.get('compareConfig').get('compareType').value == "dateRanges") {
      if (rType == 'range0' && this.chartForm.get('compareConfig').get('fromDate').value && this.chartForm.get('compareConfig').get('toDate').value)
        this.chartForm.get('compareConfig').get('displayName').patchValue(moment(this.chartForm.get('compareConfig').get('fromDate').value).format("M/D/YYYY") + ' - ' + moment(this.chartForm.get('compareConfig').get('toDate').value).format("M/D/YYYY"));
      if (rType == 'range1' && this.chartForm.get('compareConfig').get('range1').get('fromDate').value && this.chartForm.get('compareConfig').get('range1').get('toDate').value)
        this.chartForm.get('compareConfig').get('range1').get('displayName').patchValue(moment(this.chartForm.get('compareConfig').get('range1').get('fromDate').value).format("M/D/YYYY") + ' - ' + moment(this.chartForm.get('compareConfig').get('range1').get('toDate').value).format("M/D/YYYY"));
      if (rType == 'range2' && this.chartForm.get('compareConfig').get('range2').get('fromDate').value && this.chartForm.get('compareConfig').get('range2').get('toDate').value)
        this.chartForm.get('compareConfig').get('range2').get('displayName').patchValue(moment(this.chartForm.get('compareConfig').get('range2').get('fromDate').value).format("M/D/YYYY") + ' - ' + moment(this.chartForm.get('compareConfig').get('range2').get('toDate').value).format("M/D/YYYY"));
      if (rType == 'range3' && this.chartForm.get('compareConfig').get('range3').get('fromDate').value && this.chartForm.get('compareConfig').get('range3').get('toDate').value)
        this.chartForm.get('compareConfig').get('range3').get('displayName').patchValue(moment(this.chartForm.get('compareConfig').get('range3').get('fromDate').value).format("M/D/YYYY") + ' - ' + moment(this.chartForm.get('compareConfig').get('range3').get('toDate').value).format("M/D/YYYY"));
      if (rType == 'range4' && this.chartForm.get('compareConfig').get('range4').get('fromDate').value && this.chartForm.get('compareConfig').get('range4').get('toDate').value)
        this.chartForm.get('compareConfig').get('range4').get('displayName').patchValue(moment(this.chartForm.get('compareConfig').get('range4').get('fromDate').value).format("M/D/YYYY") + ' - ' + moment(this.chartForm.get('compareConfig').get('range4').get('toDate').value).format("M/D/YYYY"));
      if (rType == 'range5' && this.chartForm.get('compareConfig').get('range5').get('fromDate').value && this.chartForm.get('compareConfig').get('range5').get('toDate').value)
        this.chartForm.get('compareConfig').get('range5').get('displayName').patchValue(moment(this.chartForm.get('compareConfig').get('range5').get('fromDate').value).format("M/D/YYYY") + ' - ' + moment(this.chartForm.get('compareConfig').get('range5').get('toDate').value).format("M/D/YYYY"));
    }
  }

  getEventList(type: any) {
    this.eventService.list().pipe(takeUntil(this._onDestroy)).subscribe(
      res => {
        this.eventList = res;
        if (type && this.chartForm.get('compareConfig').get('compareType').value == "events") {
          this.onEventChange('range0', this.chartForm.get('compareConfig').get('eventId').value);
          if (this.chartForm.get('compareConfig').get('range1').get('enabled').value)
            this.onEventChange('range1', this.chartForm.get('compareConfig').get('range1').get('eventId').value);
          if (this.chartForm.get('compareConfig').get('range2').get('enabled').value)
            this.onEventChange('range2', this.chartForm.get('compareConfig').get('range2').get('eventId').value);
          if (this.chartForm.get('compareConfig').get('range3').get('enabled').value)
            this.onEventChange('range3', this.chartForm.get('compareConfig').get('range3').get('eventId').value);
          if (this.chartForm.get('compareConfig').get('range4').get('enabled').value)
            this.onEventChange('range4', this.chartForm.get('compareConfig').get('range4').get('eventId').value);
          if (this.chartForm.get('compareConfig').get('range5').get('enabled').value)
            this.onEventChange('range5', this.chartForm.get('compareConfig').get('range5').get('eventId').value);
        }
      },
      err => { }
    );
  }
  onEventChange(type: any, id: any) {
    let that = this;
    this.eventList.filter(function (el) {
      if (el.type === type) {
        el.isSelected = false;
        el.type = ""
      }
      if (el._id === id) {
        el.isSelected = true;
        el.type = type
      }
      if (type == 'range0' && el._id === id)
        that.chartForm.get('compareConfig').get('displayName').patchValue(el.eventName);
      else if (type == 'range1' && el._id === id)
        that.chartForm.get('compareConfig').get('range1').get('displayName').patchValue(el.eventName);
      else if (type == 'range2' && el._id === id)
        that.chartForm.get('compareConfig').get('range2').get('displayName').patchValue(el.eventName);
      else if (type == 'range3' && el._id === id)
        that.chartForm.get('compareConfig').get('range3').get('displayName').patchValue(el.eventName);
      else if (type == 'range4' && el._id === id)
        that.chartForm.get('compareConfig').get('range4').get('displayName').patchValue(el.eventName);
      else if (type == 'range5' && el._id === id)
        that.chartForm.get('compareConfig').get('range5').get('displayName').patchValue(el.eventName);
    });
  }

  parseData(data: any) {
    if (data.widgetData && data.widgetData._id) {
      if (data.widgetData.htmlContentRichText) {
        this.htmlContentRichText = data.widgetData.htmlContentRichText;
      }
      if (!data.widgetData.countConfig) {
        data.widgetData.countConfig = {
          formatNumber: -1,
          boxColor: "",
          valueColor: "",
          labelColor: "",
          borderThickness: 0,
          borderColor: ""
        }
      } else {

        this.boxColor[0] = data.widgetData.countConfig.boxColor;
        this.boxColor[1] = data.widgetData.countConfig.valueColor;
        this.boxColor[2] = data.widgetData.countConfig.labelColor;
        this.boxColor[3] = data.widgetData.countConfig.borderColor;
      }
      if (!data.widgetData.trendConfig) {
        data.widgetData.trendConfig = {
          boxColor: "",
          valueColor: "",
          isTrendBar: false,
          isCurrent: false,
          isPastD: false,
          isPastW: false,
          isPastM: false,
          isPastY: false
        }
      } else {
        this.boxColor[5] = data.widgetData.trendConfig.boxColor;
        this.boxColor[6] = data.widgetData.trendConfig.valueColor;
      }
      data.widgetData.isRowTotal = data.widgetData.hasOwnProperty('isRowTotal') ? data.widgetData.isRowTotal : true;
      data.widgetData.isColumnTotal = data.widgetData.hasOwnProperty('isColumnTotal') ? data.widgetData.isColumnTotal : true;
      data.isAdjustHeader = data.widgetData.hasOwnProperty('isAdjustHeader') ? data.widgetData.isAdjustHeader : false;
      if (!data.widgetData.histogramConfig) {
        data.widgetData.histogramConfig = {
          rangeType: '',
          valueType: '',
          bins: ''
        }
      }
      if (!data.widgetData.binFilter) {
        data.widgetData.binFilter = this.fb.array([])
      }
      // if (!data.widgetData.numericConfig) {
      //   data.widgetData.numericConfig = {
      //     chartLabelSettings:this.showNumericConfig,
      //     chartLabelColor: "#000000",//default settings
      //     chartLabelFontSize: 10,
      //     chartLabelDecimals: 2,
      //     chartLabelAlignment: 270,
      //     xPositionOffset:2,
      //     yPositionOffset:-15,
      //     allowOverlap:false,
      //     crop:false
      //   }
      // }  else {
      //   this.showNumericConfig = data.widgetData.numericConfig.chartLabelSettings;
      //   this.chartLabelColor = data.widgetData.numericConfig.chartLabelColor;
      // }

      if (!data.widgetData.performerConfig) {
        data.widgetData.performerConfig = {
          topOrBottom: "top",
          noOfPerformers: 5,//default settings
        }
      } else {
        data.widgetData.performerConfig = {
          topOrBottom: data.widgetData.performerConfig.topOrBottom,
          noOfPerformers: data.widgetData.performerConfig.noOfPerformers,
        }
      }

      if (data.widgetData.fetchDataFor == 'performers') {
        data.widgetData.kpiType = 'performers';
      }

      if (!data.widgetData.axisConfig) {
        data.widgetData.axisConfig = {
          y1: {
            label: "",
            decimals: 0,
          },
          y2: {
            label: "",
            decimals: 0,
          }
        }
      }
      if (!data.widgetData.visualConfig) {
        data.widgetData.visualConfig = {
          isMultiSensor: 0
        };
      }

      // if(data.widgetData.image){
      //   data.widgetData.image = data.widgetData.image
      // }
      // if (data.widgetData.numericConfig.thresholdSettings)
      //   this.thresholdColorAr = data.widgetData.numericConfig.thresholdSettings.map(ob => ob.thresholdColor);


      // data.fetchDataFor="line"
      data["isPredictive"] = data.widgetData.isPredictiveSearch;
      return data;
    }
    return {
      widgetData: {
        _id: "",
        dashboardId: data.dashboardId,
        groupId: data.groupId,
        title: "",
        order: "",
        countConfig: {
          formatNumber: -1,
          boxColor: "",
          valueColor: "",
          labelColor: "",
          borderThickness: 0,
          borderColor: "",
          // isTrendE:false,
          // trendColor:"#000"
        },
        trendConfig: {
          isTrendBar: false,
          isCurrent: false,
          isPastD: false,
          isPastW: false,
          isPastM: false,
          isPastY: false,
          boxColor: "",
          valueColor: ""
        },
        numericConfig: {

        },
        performerConfig: {
          topOrBottom: "top",
          noOfPerformers: 5,//default settings
        },
        visualConfig: {
          isMultiSensor: 0
        },
        axisConfig: {
          y1: {
            label: "",
            decimals: 0,
          },
          y2: {
            label: "",
            decimals: 0,
          }
        },
        histogramConfig: {
          rangeType: '',
          valueType: '',
          bins: ''
        },
        dateType: "",
        from: "",
        to: "",
        kpiType: "",
        widgetConfig: {
          width: ''
        },
        isRowTotal: true,
        isColumnTotal: true,
        isAdjustHeader: false,
        fetchDataFor: "",
        dataFilter: this.fb.array([]),
        binFilter: this.fb.array([]),
        isEffectedByGroupFilter: 1,
        isPredictive: false,
        displayType: "numeric",
        hideBackGround: false,
        hideTitle: false,
        hideBorder: false
      }
    };
  }

  setDataFilter(dataFilters: DataFilter[]) {
    dataFilters.forEach((v, i) => {
      this.kpiList[i] = [];
      this.kpiElementList[i] = [];
      this.selectedBrands[i] = [];
      this.selectedDevices[i] = [];
      this.selectedZones[i] = [];
      //create color array
      // this.color[i] = v.color;
      //create kpilist array

      this.widgetService.kpiList(v.kpiGroupId).pipe(takeUntil(this._onDestroy)).subscribe(res => {
        this.kpiList[i] = res;
        //create element list array
        let tempElementList = this.kpiList[i].filter(
          item => item._id === v.kpiId
        );
        if (tempElementList.length > 0 &&
          tempElementList[0].elements &&
          tempElementList[0].elements.constructor == Array
        ) {
          tempElementList[0].elements.forEach((element, index) => {
            if (element.value || element.value == 0) {
              this.kpiElementList[i].push(element);
              // this.kpiElementList[i].push('presentationType')
            }
          });
        }

        //set element select
        dataFilters.map((fields, i) => {
          let kpiList = this.kpiList[i].filter(item => item._id === fields.kpiId);
          if (kpiList.length) {
            this.kpiElementMultiSelect[i] = (kpiList[0].isElementMultiSelect ? true : false)
          }
        });
        //create selected brands array
        //removed after 19-02-2018 change: this should be available in group filter as suggested by rajiv
        // v.mapped[0].brands.forEach((id, index) => {
        //   this.widgetService.brandList(id).subscribe(res => {
        //     this.selectedBrands[i].push(res[0]);
        //   });
        // });
        //create selected devices array
        //removed after 19-02-2018 change: this should be available in group filter as suggested by rajiv
        // v.mapped[0].devices.forEach((id, index) => {
        //   this.widgetService.deviceList(id).subscribe(res => {
        //     this.selectedDevices[i].push(res[0]);
        //   });
        // });
        //create selected devices array
        // removed after 19-02-2018 change: this should be available in group filter as suggested by rajiv
        // v.mapped[0].zones.forEach((id, index) => {
        //   this.widgetService.zoneList(id).subscribe(res => {
        //     this.selectedZones[i].push(res[0]);
        //   });
        // });
      });
    });
    let thresholdSettings = this.data.widgetData.numericConfig.thresholdSettings ? this.data.widgetData.numericConfig.thresholdSettings : [];

    this.chartLabelColor = dataFilters.map((obj) => { return obj.kpiNumericConfig && obj.kpiNumericConfig.chartLabelColor ? obj.kpiNumericConfig.chartLabelColor : "#000000" })
    // this.filter00ColorObj = dataFilters.map((obj) => { return obj.geoConfig && obj.geoConfig.filter00Color ? obj.geoConfig.filter00Color : "#059505" });
    // this.filter30ColorObj = dataFilters.map((obj) => { return obj.geoConfig && obj.geoConfig.filter30Color ? obj.geoConfig.filter30Color : "#bdbd05" });
    // this.filter60ColorObj = dataFilters.map((obj) => { return obj.geoConfig && obj.geoConfig.filter60Color ? obj.geoConfig.filter60Color : "#d18904" });
    const dataFilterFGs = dataFilters.map((fields, i) => {
      let kpiList = this.kpiList[i].filter(item => item._id === fields.kpiId);
      if (kpiList.length) {
        this.kpiElementMultiSelect[i] = (kpiList[0].isElementMultiSelect ? true : false)
      }

      this.editGeoConfigObj = fields.geoConfig;

      if (fields.fetchDataFor === 'geomap')
        this.isGeoMap = true;
      // fields.segId   
      return this.fb.group({
        kpiGroupId: fields.kpiGroupId,
        fetchDataFor: fields.fetchDataFor,
        geoConfig: this.fb.group(fields.geoConfig ? {
          geoFilterType: [fields.geoConfig.geoFilterType ? fields.geoConfig.geoFilterType : "", (fields.geoConfig.geoFilterType ? Validators.required : null)],
          mapType: [fields.geoConfig.mapType ? fields.geoConfig.mapType : ""],
          segOpt: [fields.geoConfig.segOpt ? fields.geoConfig.segOpt : "or"],
          segId: [fields.geoConfig.segId ? fields.geoConfig.segId : []],
        } : {
          geoFilterType: "",
          mapType: "",
          segOpt: "or",
          segId: []
        }),
        kpiNumberFormat: fields.kpiNumberFormat,
        kpiId: fields.kpiId,
        elementId: [fields.elementId],
        label: [fields.label, Validators.required],
        isThousandSeperator: [(fields.isThousandSeperator ? fields.isThousandSeperator : false)],
        color: [(fields.color ? fields.color : "#007690"), Validators.required],
        showOnAxis: (fields.showOnAxis ? fields.showOnAxis : "y1"),
        isThreshold: [thresholdSettings.length > 0 ? thresholdSettings[i].showThresold : false],

        threshold: this.fb.group({
          islessThan: [thresholdSettings.length > 0 && thresholdSettings[i].islessThan ? thresholdSettings[i].islessThan : false],
          lessThan: [thresholdSettings.length > 0 && thresholdSettings[i].lessThan ? thresholdSettings[i].lessThan : "", (thresholdSettings.length > 0 && thresholdSettings[i].islessThan == true ? Validators.required : null)],
          lessThanColor: [thresholdSettings.length > 0 && thresholdSettings[i].lessThanColor ? thresholdSettings[i].lessThanColor : this.thresholdColorAr[0]],
          isGreaterThan: [thresholdSettings.length > 0 && thresholdSettings[i].isGreaterThan ? thresholdSettings[i].isGreaterThan : false],
          greaterThan: [thresholdSettings.length > 0 && thresholdSettings[i].greaterThan ? thresholdSettings[i].greaterThan : "", (thresholdSettings.length > 0 && thresholdSettings[i].isGreaterThan == true ? Validators.required : null)],
          greaterThanColor: [thresholdSettings.length > 0 && thresholdSettings[i].greaterThanColor ? thresholdSettings[i].greaterThanColor : this.thresholdColorAr[1]],
          isBetween: [thresholdSettings.length > 0 && thresholdSettings[i].isBetween ? thresholdSettings[i].isBetween : false],
          betweenFrom: [thresholdSettings.length > 0 && thresholdSettings[i].betweenFrom ? thresholdSettings[i].betweenFrom : "", (thresholdSettings.length > 0 && thresholdSettings[i].isBetween == true ? Validators.required : null)],
          betweenTo: [thresholdSettings.length > 0 && thresholdSettings[i].betweenTo ? thresholdSettings[i].betweenTo : "", (thresholdSettings.length > 0 && thresholdSettings[i].isBetween == true ? Validators.required : null)],
          betweenColor: [thresholdSettings.length > 0 && thresholdSettings[i].betweenColor ? thresholdSettings[i].betweenColor : this.thresholdColorAr[2]],
          // isMax: [thresholdSettings.length > 0 && thresholdSettings[i].isMax ? thresholdSettings[i].isMax : false],
          // maxColor: [thresholdSettings.length > 0 && thresholdSettings[i].maxColor ? thresholdSettings[i].maxColor : this.thresholdColorAr[3]],
          // isMin: [thresholdSettings.length > 0 && thresholdSettings[i].isMin ? thresholdSettings[i].isMin : false],
          // minColor: [thresholdSettings.length > 0 && thresholdSettings[i].minColor ? thresholdSettings[i].minColor : this.thresholdColorAr[4]],
        }),
        suffixLabel: fields.suffixLabel ? fields.suffixLabel : "",
        prefixLabel: fields.prefixLabel ? fields.prefixLabel : "",
        segId: [fields.segId],
        mapped: this.fb.group({
          siteId: (fields.mapped && fields.mapped[0] && fields.mapped[0].siteId ? fields.mapped[0].siteId : ""),
          mappedFullSite: 0,
          zones: "",
          devices: (fields.mapped && fields.mapped[0] && fields.mapped[0].devices ? fields.mapped[0].devices : []),
          brands: ""
        }),
        kpiNumericConfig: this.fb.group({
          showNumericConfig: fields.kpiNumericConfig && fields.kpiNumericConfig.showNumericConfig ? fields.kpiNumericConfig.showNumericConfig : false,
          chartLabelColor: this.chartLabelColor[i],
          chartLabelFontSize: fields.kpiNumericConfig && fields.kpiNumericConfig.chartLabelFontSize ? fields.kpiNumericConfig.chartLabelFontSize : 10,
          chartLabelAlignment: fields.kpiNumericConfig && fields.kpiNumericConfig.chartLabelAlignment == 0 ? fields.kpiNumericConfig.chartLabelAlignment : 270,
          xPositionOffset: fields.kpiNumericConfig && fields.kpiNumericConfig.xPositionOffset ? fields.kpiNumericConfig.xPositionOffset : 2,
          yPositionOffset: fields.kpiNumericConfig && fields.kpiNumericConfig.yPositionOffset ? fields.kpiNumericConfig.yPositionOffset : 0,
          allowOverlap: fields.kpiNumericConfig && fields.kpiNumericConfig.allowOverlap ? fields.kpiNumericConfig.allowOverlap : false,
          crop: fields.kpiNumericConfig && fields.kpiNumericConfig.crop ? fields.kpiNumericConfig.crop : false
        }),
        actual: (typeof fields["actual"] != 'undefined' ? fields["actual"] : true), //ripun
        predictive: (typeof fields["predictive"] != 'undefined' ? fields["predictive"] : false),//ripun
        backGroundColor: [fields.backGroundColor ? fields.backGroundColor : ""],
        borderColor: [fields.borderColor ? fields.borderColor : ""],
        pointerColor: [fields.pointerColor ? fields.pointerColor : ""],
        labelColor: [fields.labelColor ? fields.labelColor : ""],
        tooltipPosition: [fields.tooltipPosition ? fields.tooltipPosition : ""],
        transparency: [fields.transparency ? fields.transparency : 1],
        pageX: [fields.pageX ? fields.pageX : 0],
        pageY: [fields.pageY ? fields.pageY : 0],
        id: [fields.id ? fields.id : 0],
        displayType: [fields.displayType ? fields.displayType : 'value'],
      })
    });
    const dataFilterFormArray = this.fb.array(dataFilterFGs);
    this.chartForm.setControl("dataFilter", dataFilterFormArray);
    this.validateThreshold(dataFilterFGs);
    //for visual load this
    this.loadDeviceListForSite(0);
  }

  validateThreshold(dataFilters: any) {
    dataFilters.forEach((v, i) => {
      this.dataFilter.controls[i].get('isThreshold').valueChanges.pipe(takeUntil(this._onDestroy)).subscribe((type: boolean) => {
        if (type == false) {
          this.dataFilter.controls[i].get('threshold').get('islessThan').patchValue(false);
          this.dataFilter.controls[i].get('threshold').get('lessThan').patchValue('');
          this.dataFilter.controls[i].get('threshold').get('lessThanColor').patchValue(this.thresholdColorAr[0]);
          this.dataFilter.controls[i].get('threshold').get('isGreaterThan').patchValue(false);
          this.dataFilter.controls[i].get('threshold').get('greaterThan').patchValue('');
          this.dataFilter.controls[i].get('threshold').get('greaterThanColor').patchValue(this.thresholdColorAr[1]);
          this.dataFilter.controls[i].get('threshold').get('isBetween').patchValue(false);
          this.dataFilter.controls[i].get('threshold').get('betweenFrom').patchValue('');
          this.dataFilter.controls[i].get('threshold').get('betweenTo').patchValue('');
          this.dataFilter.controls[i].get('threshold').get('betweenColor').patchValue(this.thresholdColorAr[2]);
          // this.dataFilter.controls[i].get('threshold').get('isMin').patchValue(false);
          // this.dataFilter.controls[i].get('threshold').get('maxColor').patchValue(this.thresholdColorAr[3]);
          // this.dataFilter.controls[i].get('threshold').get('isMax').patchValue(false);
          // this.dataFilter.controls[i].get('threshold').get('maxColor').patchValue(this.thresholdColorAr[4]);

          this.dataFilter.controls[i].get('threshold').get('lessThan').clearValidators();
          this.dataFilter.controls[i].get('threshold').get('lessThan').updateValueAndValidity();
          this.dataFilter.controls[i].get('threshold').get('greaterThan').clearValidators();
          this.dataFilter.controls[i].get('threshold').get('greaterThan').updateValueAndValidity();
          this.dataFilter.controls[i].get('threshold').get('betweenFrom').clearValidators();
          this.dataFilter.controls[i].get('threshold').get('betweenFrom').updateValueAndValidity();
          this.dataFilter.controls[i].get('threshold').get('betweenTo').clearValidators();
          this.dataFilter.controls[i].get('threshold').get('betweenTo').updateValueAndValidity();
        }
      });
      this.dataFilter.controls[i].get('threshold').get('islessThan').valueChanges.pipe(takeUntil(this._onDestroy)).subscribe((type: boolean) => {
        if (type == true)
          this.dataFilter.controls[i].get('threshold').get('lessThan').setValidators([Validators.required]);
        else {
          this.dataFilter.controls[i].get('threshold').get('lessThan').patchValue('');
          this.dataFilter.controls[i].get('threshold').get('lessThan').clearValidators();
        }
        this.dataFilter.controls[i].get('threshold').get('lessThan').updateValueAndValidity();
      });
      this.dataFilter.controls[i].get('threshold').get('isGreaterThan').valueChanges.pipe(takeUntil(this._onDestroy)).subscribe((type: boolean) => {
        if (type == true)
          this.dataFilter.controls[i].get('threshold').get('greaterThan').setValidators([Validators.required]);
        else {
          this.dataFilter.controls[i].get('threshold').get('greaterThan').patchValue('');
          this.dataFilter.controls[i].get('threshold').get('greaterThan').clearValidators();
        }
        this.dataFilter.controls[i].get('threshold').get('greaterThan').updateValueAndValidity();
      });
      this.dataFilter.controls[i].get('threshold').get('isBetween').valueChanges.pipe(takeUntil(this._onDestroy)).subscribe((type: boolean) => {
        if (type == true) {
          this.dataFilter.controls[i].get('threshold').get('betweenFrom').setValidators([Validators.required]);
          this.dataFilter.controls[0].get('threshold').get('betweenTo').setValidators([Validators.required]);
        }
        else {
          this.dataFilter.controls[i].get('threshold').get('betweenFrom').patchValue('');
          this.dataFilter.controls[i].get('threshold').get('betweenFrom').clearValidators();
          this.dataFilter.controls[i].get('threshold').get('betweenTo').patchValue('');
          this.dataFilter.controls[i].get('threshold').get('betweenTo').clearValidators();
        }
        this.dataFilter.controls[i].get('threshold').get('betweenFrom').updateValueAndValidity();
        this.dataFilter.controls[i].get('threshold').get('betweenTo').updateValueAndValidity();
      });
    });
  }

  setHistogramFilter(binFilter: binFilter[]) {
    const binFilterFormGroups = binFilter.map((fields, i) => {
      const bingorup = this.fb.group({
        min: [fields.min, (!fields.minonly && !fields.maxonly ? Validators.required : (fields.minonly ? Validators.required : null))],
        max: [fields.max, (!fields.minonly && !fields.maxonly ? Validators.required : (fields.maxonly ? Validators.required : null))],
        minonly: fields.minonly,
        maxonly: fields.maxonly,
        label: fields.label,
        dayselection: fields.dayselection,
        monday: fields.monday,
        tuesday: fields.tuesday,
        wednesday: fields.wednesday,
        thursday: fields.thursday,
        friday: fields.friday,
        saturday: fields.saturday,
        sunday: fields.sunday,
      })

      bingorup.get('minonly').valueChanges.pipe(takeUntil(this._onDestroy)).subscribe((minonly: boolean) => {
        if (minonly) {
          bingorup.get('max').clearValidators();
        }
        else {
          bingorup.get('max').clearValidators();
          bingorup.get('max').setValidators([Validators.required]);
        }
        bingorup.get('max').updateValueAndValidity();
      })
      bingorup.get('maxonly').valueChanges.pipe(takeUntil(this._onDestroy)).subscribe((maxonly: boolean) => {
        if (maxonly) {
          bingorup.get('min').clearValidators();
        }
        else {
          bingorup.get('min').clearValidators();
          bingorup.get('min').setValidators([Validators.required]);
        }
        bingorup.get('min').updateValueAndValidity();
      })
      return bingorup;
    });
    const histogramFilterFormArray = this.fb.array(binFilterFormGroups);
    this.chartForm.setControl("binFilter", histogramFilterFormArray);
  }

  kpiTypeChanged() {
    let kt = this.chartForm.controls['kpiType'].value;
    this.chartForm.controls['widgetConfig'].get('width').patchValue(this.defaultWidth ? this.defaultWidth[kt] : 50);

    if (kt == 'comparison') {
      this.getEventList(false);
    }
    if (kt == "numeric" || kt === 'count') {
      let selectedGroup = this.dashboardGroups.filter(item => item._id === this.data.widgetData.groupId);
      if (selectedGroup[0]) {
        this.data.isPredictive = selectedGroup[0].isPredictive;
      }
    }
    else
      this.data.isPredictive = false;
    //since we have removed presentation type for numberic hence we are setting fetchDataFor
    if (kt == "numeric") {
      this.chartForm.get('fetchDataFor').patchValue("table");
    }

    if (kt != "numeric") {
      // this.showNumericConfig = false;
    }
    if (kt == "richText" || kt == "siteMap") {
      const dataFilterFormArray = this.fb.array([]);
      this.chartForm.setControl("dataFilter", dataFilterFormArray);
    }
    this.setDataFilterMaxLimit();
  }

  setDataFilterMaxLimit() {

    let maxFilter = this.maxdataFilter;
    if (this.chartForm.value.kpiType == 'comparison' && this.chartForm.get('compareConfig').get('fetchDataFor').value == 'count')
      maxFilter = 1;
    else if (["count", "visual", "trend", "performers"].includes(this.chartForm.value.kpiType)) {
      // if (this.chartForm.value.kpiType == 'count' || this.chartForm.value.kpiType == 'visual' || this.chartForm.value.kpiType == 'trend') {
      maxFilter = 1; //maxFilter
    } else if (this.chartForm.value.kpiType == 'numeric' && this.chartForm.value.fetchDataFor == 'table') {
      maxFilter = 20;
    } else {
      maxFilter = 20; //maxFilter //ripun
    }
    this.maxdataFilter = maxFilter;
  }

  dataFetchForChanged() {
    this.setDataFilterMaxLimit();
  }

  handleBinChange() {
    var _histo = this.chartForm.controls['histogramConfig'] as FormGroup;
    if (_histo.controls["bins"].value !== '') {
      let bins = parseInt(_histo.controls["bins"].value);
      if (bins > 0) {
        if (this.binFilter.length > bins) {
          this.binFilter.controls.splice(bins - 1, (this.binFilter.controls.length - bins));
        }
        else {
          let i = 0, j = this.binFilter.length, renamining = (bins - j);
          if ((<FormArray>this.chartForm.controls['binFilter']).at(j - 1))
            (<FormArray>this.chartForm.controls['binFilter']).at(j - 1).get("maxonly").setValue(false);
          while (i < renamining) {
            const bingorup = this.fb.group({
              min: ['', Validators.required],
              max: ['', Validators.required],
              minonly: false,
              maxonly: false,
              label: '',
              dayselection: 0,
              monday: true,
              tuesday: true,
              wednesday: true,
              thursday: true,
              friday: true,
              saturday: true,
              sunday: true,
            })

            bingorup.get('minonly').valueChanges.pipe(takeUntil(this._onDestroy)).subscribe((minonly: boolean) => {
              if (minonly) {
                bingorup.get('max').clearValidators();
              }
              else {
                bingorup.get('max').clearValidators();
                bingorup.get('max').setValidators([Validators.required]);
              }
              bingorup.get('max').updateValueAndValidity();
            })
            bingorup.get('maxonly').valueChanges.pipe(takeUntil(this._onDestroy)).subscribe((maxonly: boolean) => {
              if (maxonly) {
                bingorup.get('min').clearValidators();
              }
              else {
                bingorup.get('min').clearValidators();
                bingorup.get('min').setValidators([Validators.required]);
              }
              bingorup.get('min').updateValueAndValidity();
            })
            this.binFilter.push(bingorup);
            i++;
          }
        }

      }
      else {
        this.binFilter.controls = [];
      }
    }
  }

  countPriorDate(days) {
    if (days != '' && !isNaN(days)) {
      var dt = new Date();
      dt.setDate(dt.getDate() - parseInt(days));
      return (dt.getMonth() + 1) + '/' + dt.getDate() + '/' + dt.getFullYear() + '(' + days + ' day(s) before today)';
    }
    else {
      return 'Number of day(s) before today';
    }
  }

  onChangeValueType(val: any) {
    if (val.checked)
      this.isvalueType = false
  }

  onChangeValue(val: any) {
    if (val.checked)
      this.isSelected = false
  }

  addFilter() {
    this.setDataFilterMaxLimit();
    let maxFilter = this.maxdataFilter;
    maxFilter -= 1; //max filter count should me less than what is defineds

    if (this.dataFilter.length > maxFilter) {
      return;
    }

    this.isPresentationErr.push(false);
    //this.thresholdColorAr.push("#FF4500");
    this.chartLabelColor.push("#000000");
    // this.filter00ColorObj.push("#059505");
    // this.filter30ColorObj.push("#bdbd05");
    // this.filter60ColorObj.push("#d18904");
    this.dataFilter.push(
      this.fb.group({
        kpiGroupId: "",
        kpiNumberFormat: 0,
        fetchDataFor: "",
        geoConfig: this.fb.group({
          geoFilterType: "",
          mapType: "",
          segOpt: "or",
          segId: [[]]
        }),
        labelSettings: "",
        kpiId: "",
        elementId: [[]],
        label: ["", Validators.required],
        isThousandSeperator: false,
        color: "",
        showOnAxis: "y1",
        isThreshold: false,
        threshold: this.fb.group({
          islessThan: false,
          lessThan: "",
          lessThanColor: "#e1ffe8",
          isGreaterThan: false,
          greaterThan: "",
          greaterThanColor: "#ffede1",
          isBetween: false,
          betweenFrom: "",
          betweenTo: "",
          betweenColor: "#ffffda",
          // isMin: false,
          // minColor: "#ffdbdb",
          // isMax: false,
          // maxColor: "#c4f3af",
        }),
        //thresholdColor: "#FF4500",
        suffixLabel: "",
        prefixLabel: "",
        predictive: false, //ripun
        actual: true,//ripun
        segId: [],
        mapped: this.fb.group({
          siteId: "",
          mappedFullSite: "",
          zones: "",
          devices: "",
          brands: ""
        }),
        kpiNumericConfig: this.fb.group({
          showNumericConfig: false,
          chartLabelColor: "#000000",//default settings
          chartLabelFontSize: 10,
          chartLabelAlignment: 270,
          xPositionOffset: 2,
          yPositionOffset: 0,
          allowOverlap: false,
          crop: false
        }),
        displayType : 'value'
      })
    );
    this.chartForm.get('fetchDataFor').valueChanges.pipe(takeUntil(this._onDestroy)).subscribe((type: string) => {
      if (type === 'geomap') {
        this.isGeoMap = true;
        this.dataFilter.controls[0].get('geoConfig').get('geoFilterType').setValidators([Validators.required]);
        this.dataFilter.controls[0].get('geoConfig').get('mapType').setValidators([Validators.required]);
      }
      else {
        this.isGeoMap = false;
        this.dataFilter.controls[0].get('geoConfig').get('geoFilterType').clearValidators();
        this.dataFilter.controls[0].get('geoConfig').get('mapType').clearValidators();
      }
    });
    this.validateThreshold(this.dataFilter.controls);
  }

  presentationCh() {
    let firstPresentT;
    this.chartForm.get("dataFilter").value.forEach((element, i) => {
      if (i == 0) {
        firstPresentT = this.chartForm.value.kpiType == 'comparison' && this.chartForm.get('compareConfig').get('fetchDataFor').value ? this.chartForm.get('compareConfig').get('fetchDataFor').value : element.fetchDataFor;
        this.chartForm.get('fetchDataFor').setValue(firstPresentT);
      }
      else {
        let selectedPresentT = this.chartForm.value.kpiType == 'comparison' && this.chartForm.get('compareConfig').get('fetchDataFor').value ? this.chartForm.get('compareConfig').get('fetchDataFor').value : element.fetchDataFor;
        if ((firstPresentT == "table" && !["table", ""].includes(selectedPresentT)) || (firstPresentT != "table" && ["table", ""].includes(selectedPresentT))) {
          this.isPresentationErr[i] = true;
          this.isSubmitted = 1;
        }
        else {
          this.isPresentationErr[i] = false;
          this.isSubmitted = 0;
        }
      }
    });
  }

  removeFilter(index) {
    if (confirm("Are you sure you want to remove this filter?") == false) {
      return false;
    }
    this.dataFilter.removeAt(index);
    this.isPresentationErr.splice(index, 1);
    this.presentationCh();
  }

  removeBinFilter(index) {
    if (confirm("Are you sure you want to remove this bin?") == false) {
      return false;
    }
    this.binFilter.removeAt(index);
    var _histo = this.chartForm.controls['histogramConfig'] as FormGroup;
    if (_histo.controls["bins"].value > 1)
      _histo.controls["bins"].setValue(_histo.controls["bins"].value - 1);
    else
      _histo.controls["bins"].setValue('');
  }

  addZero(i) {
    if (i < 10) {
      i = "0" + i;
    }
    return i;
  }

  getEventsDates(id: any) {
    if (this.eventList.length > 0) {
      var data = this.eventList.find(x => x._id == id);
      if (data) {
        data = {
          firstDay: data.from.replace('T', ' ').replace('.000Z', ''),
          lastDay: data.to.replace('T', ' ').replace('.000Z', ''), eventName: data.eventName
        };
        return data;
      }
    }
  }

  onSubmit(form: any) {
    if (!this.chartForm.valid) {
      return false;
    }
    if (form.compareConfig && form.compareConfig.fetchDataFor != '') {
      if (!form.compareConfig.valueType.Value && !form.compareConfig.valueType.Variation && !form.compareConfig.valueType.Difference) {
        this.isvalueType = true;
        return false;
      } else if (this.displayMessage != '') {
        return false;
      } else {
        this.isvalueType = false;
      }
    }

    if (form.kpiType == 'compareDate' && form.compareDateConfig && form.compareDateConfig.fetchDataFor != '') {
      if (!form.compareDateConfig.date1.enabled && !form.compareDateConfig.date2.enabled && !form.compareDateConfig.date3.enabled && !form.compareDateConfig.date4.enabled) {
        this.isSelected = true;
        return false;
      }else {
        this.isSelected = false;
      }
    }

    this.isSubmitted = 1;
    //create date time from datepicker
    let currentTime: any = new Date();
    currentTime =
      this.addZero(currentTime.getHours()) +
      ":" +
      this.addZero(currentTime.getMinutes()) +
      ":" +
      this.addZero(currentTime.getSeconds());
    if (typeof form.from == "object") {
      //get from date
      let fromDate = form.from._i.year;

      let fMonth =
        (parseInt(form.from._i.month) + 1).toString().length == 1
          ? "0" + (form.from._i.month + 1)
          : form.from._i.month + 1;
      fromDate += "-" + fMonth;

      let fDate =
        form.from._i.date.toString().length == 1
          ? "0" + form.from._i.date
          : form.from._i.date;
      fromDate += "-" + fDate + " " + currentTime;

      //add from date
      form.from = fromDate;
    }

    if (typeof form.to == "object") {
      //get to date
      let toDate = form.to._i.year;

      let tMonth =
        (parseInt(form.to._i.month) + 1).toString().length == 1
          ? "0" + (form.to._i.month + 1)
          : form.to._i.month + 1;
      toDate += "-" + tMonth;

      let tDate =
        form.to._i.date.toString().length == 1
          ? "0" + form.to._i.date
          : form.to._i.date;
      toDate += "-" + tDate + " " + currentTime;

      //add to date
      form.to = toDate;
    }

    if (form.dateType != "Custom") {
      form.from = "";
      form.to = "";
    }

    form.isEffectedByGroupFilter = (form.isEffectedByGroupFilter ? 1 : 0);

    //count box config
    form.countConfig.boxColor = this.boxColor[0];
    form.countConfig.valueColor = this.boxColor[1];
    form.countConfig.labelColor = this.boxColor[2];
    form.countConfig.borderColor = this.boxColor[3];
    form.countConfig.trendColor = this.boxColor[4];

    // form.numericConfig.chartLabelSettings = this.showNumericConfig;
    // form.numericConfig.chartLabelColor = this.chartLabelColor;


    form.numericConfig.thresholdList = form.dataFilter.map((obj, i) => {
      var rObj = {};
      rObj["islessThan"] = obj.threshold.islessThan;
      rObj["lessThan"] = obj.threshold.lessThan;
      rObj["lessThanColor"] = obj.threshold.lessThanColor;
      rObj["isGreaterThan"] = obj.threshold.isGreaterThan;
      rObj["greaterThan"] = obj.threshold.greaterThan;
      rObj["greaterThanColor"] = obj.threshold.greaterThanColor;
      rObj["isBetween"] = obj.threshold.isBetween;
      rObj["betweenFrom"] = obj.threshold.betweenFrom;
      rObj["betweenTo"] = obj.threshold.betweenTo;
      rObj["betweenColor"] = obj.threshold.betweenColor;
      // rObj["isMax"] = obj.threshold.isMax;
      // rObj["maxColor"] = obj.threshold.maxColor;
      // rObj["isMin"] = obj.threshold.isMin;
      // rObj["minColor"] = obj.threshold.minColor;
      rObj["label"] = obj.label;
      rObj["showThresold"] = obj.isThreshold
      return rObj;
    });
    // form.numericConfig.isThreshold = form.numericConfig.thresholdList && form.numericConfig.thresholdList.length > 0 ? true :false;


    //trend box config
    form.trendConfig.boxColor = this.boxColor[5];
    form.trendConfig.valueColor = this.boxColor[6];

    let outerFetchDataFor;

    //create dataFilter array
    form.dataFilter.forEach((v, i) => {
      outerFetchDataFor = !outerFetchDataFor && v.fetchDataFor ? v.fetchDataFor : outerFetchDataFor;
      if (!this.data.isPredictive) {
        v.actual = true
        v.predictive = false;
      }
      // added after 19-02-2018 change: this should be available in group filter as suggested by rajiv
      let mapped = v.mapped;
      v.mapped = [{}];
      v.color = !v.color ? this.boxColor[0] : v.color;
      if (form.kpiType == "visual" && form.fetchDataFor != 'geoMap') {
        if (mapped.devices != null) {
          mapped.devices = [mapped.devices];
        }
        v.mapped[0] = mapped;
      } if (form.kpiType == "visual" && form.fetchDataFor == 'geoMap') {
        v.fetchDataFor = "geoMap";
      }
      if (form.kpiType == "histogram")
        v.fetchDataFor = "bar";
      v.kpiNumericConfig.chartLabelColor = this.chartLabelColor[i];

      if (this.editGeoConfigObj !== null && (v.fetchDataFor == 'geomap' || v.kpiGroupId == '60539299b7236f5f6ca85b37')) {
        if (v.geoConfig.geoFilterType == 'localfilter') {
          v.geoConfig.locationType = this.editGeoConfigObj.locationType ? this.editGeoConfigObj.locationType : "";
          v.geoConfig.ageType = this.editGeoConfigObj.ageType ? this.editGeoConfigObj.ageType : "";
          v.geoConfig.segmentType = this.editGeoConfigObj.segmentType ? this.editGeoConfigObj.segmentType : "";
          v.geoConfig.visitType = this.editGeoConfigObj.visitType ? this.editGeoConfigObj.visitType : "";
          v.geoConfig.saveType = this.editGeoConfigObj.saveType ? this.editGeoConfigObj.saveType : "";
          v.geoConfig.questionName = this.editGeoConfigObj.questionName ? this.editGeoConfigObj.questionName : "";
          v.geoConfig.ageRange = this.editGeoConfigObj.ageRange ? this.editGeoConfigObj.ageRange : "";
          v.geoConfig.age = this.editGeoConfigObj.age ? this.editGeoConfigObj.age : "";
          v.geoConfig.ageOperator = this.editGeoConfigObj.ageOperator ? this.editGeoConfigObj.ageOperator : "equal";
          v.geoConfig.visit = this.editGeoConfigObj.visit ? this.editGeoConfigObj.visit : "";
          v.geoConfig.visitRange = this.editGeoConfigObj.visitRange ? this.editGeoConfigObj.visitRange : "";
          v.geoConfig.visitOperator = this.editGeoConfigObj.visitOperator ? this.editGeoConfigObj.visitOperator : "";
          v.geoConfig.filterFromDate = this.editGeoConfigObj.filterFromDate ? this.editGeoConfigObj.filterFromDate : "";
          v.geoConfig.filterToDate = this.editGeoConfigObj.filterToDate ? this.editGeoConfigObj.filterToDate : "";
          v.geoConfig.segOpt = this.editGeoConfigObj.segOpt ? this.editGeoConfigObj.segOpt : "or";
          v.geoConfig.segId = this.editGeoConfigObj.segId ? this.editGeoConfigObj.segId : [];
          if (v.geoConfig.locationType == "customlocation") {
            v.geoConfig.drawMapType = this.editGeoConfigObj.drawMapType ? this.editGeoConfigObj.drawMapType : "";
            if (v.geoConfig.drawMapType == GeoFilterNext.drawSite || v.geoConfig.drawMapType == GeoFilterNext.geoRadius)
              v.geoConfig.geoLatLng = this.editGeoConfigObj.geoLatLng ? this.editGeoConfigObj.geoLatLng : "";
            if (v.geoConfig.drawMapType == GeoFilterNext.geoRadius)
              v.geoConfig.radius = this.editGeoConfigObj.radius ? this.editGeoConfigObj.radius : "";
          } else if (v.geoConfig.locationType == "site") {
            v.geoConfig.geoSite = this.editGeoConfigObj.geoSite ? this.editGeoConfigObj.geoSite : "";
          }
        }
      }
    });

    if (form.kpiType == "histogram") {
      form.fetchDataFor = "bar";
      if (form.histogramConfig.rangeType == 'date' && form.histogramConfig.valueType == 'absolute') {
        form.binFilter.forEach((v, i) => {
          v.min = this.commonService.getDateConverted(v.min, "YYYY-MM-DD HH:mm:ss");
          v.max = this.commonService.getDateConverted(v.max, "YYYY-MM-DD HH:mm:ss");
        });
      }
    }

    //if kpi type is table change it to numeric and pass fetchdatafor as 'table'
    if (form.kpiType == "numeric") {
      form.fetchDataFor = outerFetchDataFor;
    }
    else if (form.kpiType == "performers") {
      form.kpiType = "numeric";
      form.fetchDataFor = "performers";
    }
    // else if(form.kpiType == "numeric") {
    //   form.fetchDataFor = form.dataFilter && form.dataFilter.length > 0 ? form.dataFilter[0].fetchDataFor : "bar";
    // }

    if (form.kpiType == "count" || form.kpiType == "trend") {
      form.fetchDataFor = "box";
    }

    form.htmlContentRichText = this.htmlContentRichText;
    if (form.kpiType == "richText") {
      form.fetchDataFor = "NA";
    }


    if (form.kpiType == "siteMap") {
      form.fetchDataFor = "NA";
    }

    if (form.kpiType != "visual") {
      form.displayType = "";
    }

    if (form.fetchDataFor == "pie") {
      form.axisConfig = {
        y1: {
          label: "",
          decimals: 0,
        },
        y2: {
          label: "",
          decimals: 0,
        }
      }
    }
    if (form.compareConfig && form.kpiType == 'comparison') {
      form.fetchDataFor = form.compareConfig.fetchDataFor;
      if (form.compareConfig.valueType.differenceName == '' || form.compareConfig.valueType.differenceName == null)
        form.compareConfig.valueType.differenceName = 'Difference';
      if (form.compareConfig.valueType.variationName == '' || form.compareConfig.valueType.variationName == null)
        form.compareConfig.valueType.variationName = 'Variation';
      if ((form.compareConfig.compareType == 'dateRanges' || form.compareConfig.compareType == 'events' || form.compareConfig.compareType == 'periodOver') && form.compareConfig.fetchDataFor == 'count')
        form.fetchDataFor = "box";

      if (form.compareConfig.segregateDate && form.compareConfig.segregateName == '')
        form.compareConfig.segregateName = form.compareConfig.segregateDate.charAt(0).toUpperCase() + form.compareConfig.segregateDate.slice(1);

      if (form.compareConfig.tableAggregator.total && form.compareConfig.aggregatorNames.totalName == '')
        form.compareConfig.aggregatorNames.totalName = 'Total';
      if (form.compareConfig.tableAggregator.count && form.compareConfig.aggregatorNames.countName == '')
        form.compareConfig.aggregatorNames.countName = 'Count';
      if (form.compareConfig.tableAggregator.average && form.compareConfig.aggregatorNames.averageName == '')
        form.compareConfig.aggregatorNames.averageName = 'Average';
      if (form.compareConfig.tableAggregator.min && form.compareConfig.aggregatorNames.minName == '')
        form.compareConfig.aggregatorNames.minName = 'Min';
      if (form.compareConfig.tableAggregator.max && form.compareConfig.aggregatorNames.maxName == '')
        form.compareConfig.aggregatorNames.maxName = 'Max';

      if (form.compareConfig.compareType == 'dateRanges') {
        let dateObj = this.commonService.convertDate('Custom', form.compareConfig.fromDate, form.compareConfig.toDate);
        form.compareConfig.fromDate = dateObj.firstDay;
        form.compareConfig.toDate = dateObj.lastDay;
        form.compareConfig.eventId = "";
        if (form.compareConfig.range1.enabled) {
          let dateObj = this.commonService.convertDate('Custom', form.compareConfig.range1.fromDate, form.compareConfig.range1.toDate);
          form.compareConfig.range1.fromDate = dateObj.firstDay;
          form.compareConfig.range1.toDate = dateObj.lastDay;
          form.compareConfig.range1.eventId = "";
        }
        if (form.compareConfig.range2.enabled) {
          let dateObj = this.commonService.convertDate('Custom', form.compareConfig.range2.fromDate, form.compareConfig.range2.toDate);
          form.compareConfig.range2.fromDate = dateObj.firstDay;
          form.compareConfig.range2.toDate = dateObj.lastDay;
          form.compareConfig.range2.eventId = "";
        }
        if (form.compareConfig.range3.enabled) {
          let dateObj = this.commonService.convertDate('Custom', form.compareConfig.range3.fromDate, form.compareConfig.range3.toDate);
          form.compareConfig.range3.fromDate = dateObj.firstDay;
          form.compareConfig.range3.toDate = dateObj.lastDay;
          form.compareConfig.range3.eventId = "";
        }
        if (form.compareConfig.range4.enabled) {
          let dateObj = this.commonService.convertDate('Custom', form.compareConfig.range4.fromDate, form.compareConfig.range4.toDate);
          form.compareConfig.range4.fromDate = dateObj.firstDay;
          form.compareConfig.range4.toDate = dateObj.lastDay;
          form.compareConfig.range4.eventId = "";
        }
        if (form.compareConfig.range5.enabled) {
          let dateObj = this.commonService.convertDate('Custom', form.compareConfig.range5.fromDate, form.compareConfig.range5.toDate);
          form.compareConfig.range5.fromDate = dateObj.firstDay;
          form.compareConfig.range5.toDate = dateObj.lastDay;
          form.compareConfig.range5.eventId = "";
        }
      } else if (form.compareConfig.compareType == 'events') {
        if (form.compareConfig.eventId) {
          let dateObj = this.getEventsDates(form.compareConfig.eventId);
          form.compareConfig.fromDate = dateObj.firstDay;
          form.compareConfig.toDate = dateObj.lastDay;
        }
        if (form.compareConfig.range1.enabled) {
          let dateObj = this.getEventsDates(form.compareConfig.range1.eventId);
          form.compareConfig.range1.fromDate = dateObj.firstDay;
          form.compareConfig.range1.toDate = dateObj.lastDay;
        }
        if (form.compareConfig.range2.enabled) {
          let dateObj = this.getEventsDates(form.compareConfig.range2.eventId);
          form.compareConfig.range2.fromDate = dateObj.firstDay;
          form.compareConfig.range2.toDate = dateObj.lastDay;
        }
        if (form.compareConfig.range3.enabled) {
          let dateObj = this.getEventsDates(form.compareConfig.range3.eventId);
          form.compareConfig.range3.fromDate = dateObj.firstDay;
          form.compareConfig.range3.toDate = dateObj.lastDay;
        }
        if (form.compareConfig.range4.enabled) {
          let dateObj = this.getEventsDates(form.compareConfig.range4.eventId);
          form.compareConfig.range4.fromDate = dateObj.firstDay;
          form.compareConfig.range4.toDate = dateObj.lastDay;
        }
        if (form.compareConfig.range5.enabled) {
          let dateObj = this.getEventsDates(form.compareConfig.range5.eventId);
          form.compareConfig.range5.fromDate = dateObj.firstDay;
          form.compareConfig.range5.toDate = dateObj.lastDay;
        }
      } else if (form.compareConfig.compareType == 'periodOver') {
        if (form.compareConfig.eventId == 'Custom') {
          let datefObj = this.commonService.convertDate('Custom', form.compareConfig.fromDate, form.compareConfig.toDate);
          form.compareConfig.fromDate = datefObj.firstDay;
          form.compareConfig.toDate = datefObj.lastDay;
          if (form.compareConfig.range1.enabled) {
            form.compareConfig.range1.fromDate = moment(datefObj.firstDay).subtract(1, 'days').format("YYYY-MM-DD HH:mm:ss");
            form.compareConfig.range1.toDate = moment(datefObj.lastDay).subtract(1, 'days').format("YYYY-MM-DD HH:mm:ss");
          }
          if (form.compareConfig.range2.enabled) {
            form.compareConfig.range2.fromDate = moment(datefObj.firstDay).subtract(1, 'weeks').format("YYYY-MM-DD HH:mm:ss");
            form.compareConfig.range2.toDate = moment(datefObj.lastDay).subtract(1, 'weeks').format("YYYY-MM-DD HH:mm:ss");
          }
          if (form.compareConfig.range3.enabled) {
            form.compareConfig.range3.fromDate = moment(datefObj.firstDay).subtract(1, 'months').format("YYYY-MM-DD HH:mm:ss");
            form.compareConfig.range3.toDate = moment(datefObj.lastDay).subtract(1, 'months').format("YYYY-MM-DD HH:mm:ss");
          }
          if (form.compareConfig.range4.enabled) {
            form.compareConfig.range4.fromDate = moment(datefObj.firstDay).subtract(1, 'years').format("YYYY-MM-DD HH:mm:ss");
            form.compareConfig.range4.toDate = moment(datefObj.lastDay).subtract(1, 'years').format("YYYY-MM-DD HH:mm:ss");
          }
          if (form.compareConfig.range5.enabled) {
            form.compareConfig.range5.fromDate = moment(datefObj.firstDay).subtract(2, 'years').format("YYYY-MM-DD HH:mm:ss");
            form.compareConfig.range5.toDate = moment(datefObj.lastDay).subtract(2, 'years').format("YYYY-MM-DD HH:mm:ss");
          }
        }
        else if (["MTD", "YTD", "WTD"].includes(form.compareConfig.eventId)) {
          if (form.compareConfig.fromDate) {
            let dateObj = this.commonService.convertDate('Custom', form.compareConfig.fromDate, form.compareConfig.fromDate);
            form.compareConfig.toDate = dateObj.lastDay;
          }
        }
      }
    }

    if (form.compareDateConfig && form.kpiType == 'compareDate') {
      form.fetchDataFor = form.compareDateConfig.fetchDataFor || 'table';
      form.compareType = form.compareDateConfig.compareType || 'aggregate';
      form.dateType = form.compareDateConfig.dateType || 'customDate';
     
      if (form.compareDateConfig.valueType.differenceName == '' || form.compareDateConfig.valueType.differenceName == null)
        form.compareDateConfig.valueType.differenceName = 'Difference';
      if (form.compareDateConfig.valueType.variationName == '' || form.compareDateConfig.valueType.variationName == null)
        form.compareDateConfig.valueType.variationName = 'Variation';

      if (form.compareDateConfig.tableAggregator.total && form.compareDateConfig.aggregatorNames.totalName == '')
        form.compareDateConfig.aggregatorNames.totalName = 'Total';
      if (form.compareDateConfig.tableAggregator.count && form.compareDateConfig.aggregatorNames.countName == '')
        form.compareDateConfig.aggregatorNames.countName = 'Count';
      if (form.compareDateConfig.tableAggregator.average && form.compareDateConfig.aggregatorNames.averageName == '')
        form.compareDateConfig.aggregatorNames.averageName = 'Average';
      if (form.compareDateConfig.tableAggregator.min && form.compareDateConfig.aggregatorNames.minName == '')
        form.compareDateConfig.aggregatorNames.minName = 'Min';
      if (form.compareDateConfig.tableAggregator.max && form.compareDateConfig.aggregatorNames.maxName == '')
        form.compareDateConfig.aggregatorNames.maxName = 'Max';

      if(form.compareDateConfig.compareType == 'daily'){
        let datefObj = this.commonService.convertDate('Custom', form.compareDateConfig.fromDate, form.compareDateConfig.toDate);
        if(form.compareDateConfig.dateType == 'monthTillDate' || form.compareDateConfig.dateType == 'monthTillLastDate'){
          datefObj = this.commonService.convertDate('Today', form.compareDateConfig.fromDate, form.compareDateConfig.toDate);
        }
        form.compareDateConfig.fromDate = datefObj.firstDay;
        form.compareDateConfig.toDate = datefObj.lastDay;
        if (form.compareDateConfig.date1.enabled) {
          form.compareDateConfig.date1.fromDate = datefObj.firstDay;
          form.compareDateConfig.date1.toDate = datefObj.lastDay;
        }
        if (form.compareDateConfig.date2.enabled) {
          form.compareDateConfig.date2.fromDate = moment.utc(datefObj.firstDay, "YYYY-MM-DD HH:mm:ss").startOf('months').format("YYYY-MM-DD HH:mm:ss");
          form.compareDateConfig.date2.toDate = datefObj.lastDay;
        }
        if (form.compareDateConfig.date3.enabled) {
          form.compareDateConfig.date3.fromDate = moment.utc(datefObj.firstDay, "YYYY-MM-DD HH:mm:ss").startOf('years').format("YYYY-MM-DD HH:mm:ss");
          form.compareDateConfig.date3.toDate = datefObj.lastDay;
        }
        if (form.compareDateConfig.date4.enabled) {
          form.compareDateConfig.date4.fromDate = moment().startOf('years').format("YYYY-MM-DD HH:mm:ss");
          form.compareDateConfig.date4.toDate = moment().endOf('day').format("YYYY-MM-DD HH:mm:ss");
        }
      }else{
        if (form.compareDateConfig.date1.enabled) {
          form.compareDateConfig.date1.fromDate = moment().startOf('day').subtract(1, 'days').format("YYYY-MM-DD HH:mm:ss");
          form.compareDateConfig.date1.toDate = moment().endOf('day').subtract(1, 'days').format("YYYY-MM-DD HH:mm:ss");
        }
        if (form.compareDateConfig.date2.enabled) {
          form.compareDateConfig.date2.fromDate = moment().startOf('months').format("YYYY-MM-DD HH:mm:ss");
          form.compareDateConfig.date2.toDate = moment().endOf('day').format("YYYY-MM-DD HH:mm:ss");
        }
        if (form.compareDateConfig.date3.enabled) {
          form.compareDateConfig.date3.fromDate = moment().subtract(1, 'months').startOf('months').format("YYYY-MM-DD HH:mm:ss");
          form.compareDateConfig.date3.toDate = moment().subtract(1, 'months').endOf('months').format("YYYY-MM-DD HH:mm:ss");
        }
        if (form.compareDateConfig.date4.enabled) {
          form.compareDateConfig.date4.fromDate = moment().startOf('years').format("YYYY-MM-DD HH:mm:ss");
          form.compareDateConfig.date4.toDate = moment().endOf('day').format("YYYY-MM-DD HH:mm:ss");
        }
      }
    }

    if(form.kpiType == 'compareDate' && form.compareDateConfig.compareType == 'aggregate'){
      form.isRowTotal = true;
      form.isColumnTotal = false;
    }
    //ripun
    if (form._id == "") {
      // if (!["count", "box", "table"].includes(form.fetchDataFor))
      //   form.widgetConfig.width = 50;
      // else if (form.fetchDataFor == "box")
      //   form.widgetConfig.width = 25;
      this.widgetService.create(form).pipe(takeUntil(this._onDestroy)).subscribe(
        res => {
          this.dialogRef.close();
          this.widgetService.sendAction("createWidget", { groupId: form.groupId });
          this.isSubmitted = 0;
        },
        err => {
          this.isSubmitted = 0;
        }
      );
    } else {
      form.widgetId = form._id;
      this.widgetService.update(form).pipe(takeUntil(this._onDestroy)).subscribe(
        res => {
          this.dialogRef.close();
          this.widgetService.sendAction("updateWidget", { groupId: form.groupId, widgetId: form._id });
          this.isSubmitted = 0;
        },
        err => {
          this.isSubmitted = 0;
        }
      );
    }
  }

  /*
    not using currently
    start
  */

  onKeyUp(index, control) {
    //if brands function keyup
    if (control == "brands") {
      let tempControl = this.chartForm.controls.dataFilter["controls"][index]
        .controls["mapped"].controls["brands"];
      tempControl.valueChanges.debounceTime(400).pipe(takeUntil(this._onDestroy)).subscribe(name => {
        if (name) {
          this.widgetService.brandList("", name).pipe(takeUntil(this._onDestroy)).subscribe(r => {
            if (r) {
              this.brandList = r;
            }
          });
        }
      });
    }
    //if zones function keyup
    if (control == "zones") {
      let tempControl = this.chartForm.controls.dataFilter["controls"][index]
        .controls["mapped"].controls["zones"];
      let site = this.chartForm.controls.dataFilter["controls"][index].controls[
        "mapped"
      ].controls["siteId"].value;
      let siteId = site;
      tempControl.valueChanges.debounceTime(400).pipe(takeUntil(this._onDestroy)).subscribe(name => {
        if (name) {
          this.widgetService.zoneList("", name, siteId).pipe(takeUntil(this._onDestroy)).subscribe(r => {
            if (r) {
              this.zoneList = r;
            }
          });
        }
      });
    }
    //if devices function keyup
    if (control == "devices") {
      let tempControl = this.chartForm.controls.dataFilter["controls"][index]
        .controls["mapped"].controls["devices"];
      let site = this.chartForm.controls.dataFilter["controls"][index].controls[
        "mapped"
      ].controls["siteId"].value;
      let siteId = site;
      tempControl.valueChanges.debounceTime(400).pipe(takeUntil(this._onDestroy)).subscribe(name => {
        if (name) {
          this.widgetService.deviceList("", name, siteId).pipe(takeUntil(this._onDestroy)).subscribe(r => {
            if (r) {
              this.deviceList = r;
            }
          });
        }
      });
    }
  }

  //display name on autocomplete
  //for brands
  displayBrandName(brand?: Brand): string | undefined {
    return brand ? brand.brandName : undefined;
  }
  //for zones
  displayZoneName(zone?: Zone): string | undefined {
    return zone ? zone.name : undefined;
  }
  //for devices
  displayDeviceName(device?: Zone): string | undefined {
    return device ? device.deviceName : undefined;
  }

  //remove brands chip
  removeBrand(brand: any, i): void {
    let index = this.selectedBrands[i].indexOf(brand);
    if (index >= 0) {
      this.selectedBrands[i].splice(index, 1);
    }
  }

  //remove zones chip
  removeZone(zone: any, i): void {
    let index = this.selectedZones[i].indexOf(zone);
    if (index >= 0) {
      this.selectedZones[i].splice(index, 1);
    }
  }

  //remove devices chip
  removeDevice(device: any, i): void {
    let index = this.selectedDevices[i].indexOf(device);
    if (index >= 0) {
      this.selectedDevices[i].splice(index, 1);
    }
  }

  //On select of autocomplete
  //for brands
  onBrandSelect(brand: any, index) {
    let keepGoing = true;
    if (!this.selectedBrands[index]) {
      this.selectedBrands[index] = [];
    }

    this.selectedBrands[index].forEach((v, i) => {
      if (keepGoing) {
        if (v._id == brand._id) {
          keepGoing = false;
          this.chartForm.controls.dataFilter["controls"][index].controls[
            "mapped"
          ].controls["brands"].setValue("");
        }
      }
    });

    if (keepGoing) {
      brand.brandId = brand._id;
      this.selectedBrands[index].push(brand);
      this.chartForm.controls.dataFilter["controls"][index].controls[
        "mapped"
      ].controls["brands"].setValue("");
    }
  }
  //for zones
  onZoneSelect(zone: any, index) {
    let keepGoing = true;
    if (!this.selectedZones[index]) {
      this.selectedZones[index] = [];
    }

    this.selectedZones[index].forEach((v, i) => {
      if (keepGoing) {
        if (v._id == zone._id) {
          keepGoing = false;
          this.chartForm.controls.dataFilter["controls"][index].controls[
            "mapped"
          ].controls["zones"].setValue("");
        }
      }
    });

    if (keepGoing) {
      zone.brandId = zone._id;
      this.selectedZones[index].push(zone);
      this.chartForm.controls.dataFilter["controls"][index].controls[
        "mapped"
      ].controls["zones"].setValue("");
    }
  }
  //on devices
  onDeviceSelect(device: any, index) {
    let keepGoing = true;
    if (!this.selectedDevices[index]) {
      this.selectedDevices[index] = [];
    }

    this.selectedDevices[index].forEach((v, i) => {
      if (keepGoing) {
        if (v._id == device._id) {
          keepGoing = false;
          this.chartForm.controls.dataFilter["controls"][index].controls[
            "mapped"
          ].controls["devices"].setValue("");
        }
      }
    });

    if (keepGoing) {
      device.brandId = device._id;
      this.selectedDevices[index].push(device);
      this.chartForm.controls.dataFilter["controls"][index].controls[
        "mapped"
      ].controls["devices"].setValue("");
    }
  }

  onFileChange(event: any) {
    var file = event.target.files[0];
    this.imageName = file.name;
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.image_url = reader.result;
      this.chartForm.get("image").setValue(reader.result)
      this.chartForm.get("imageName").setValue(file.name)
    }
  }

  /*
    not using currently
    end
  */
}


// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/private-dashboard/chart/chart.dialog.ts